import {
  ComplianceStatus,
  getComplianceStatusFromCode,
} from '@/warranty/domain/entities/compliance-status';
import {
  DataStatus,
  getDataStatusFromCode,
} from '@/warranty/domain/entities/data-status';
import type { WarrantyIDStatus } from '@/warranty/domain/entities/warranty-id-status';
import {
  getWarrantyCoverageStatusFromCode,
  WarrantyCoverageStatus,
} from '@/warranty/domain/entities/warranty-status';

const dummyWarrantyIDStatusesRaw = [
  {
    id: '18510550128694977',
    fullFrontendId: 'Country_Corner/B01/Rack_01',
    ageInYears: 2.73972602739726,
    throughputTotal: 360800000.0,
    cyclesTotal: 902.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.0,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B01',
    unitFullId: 'Country_Corner/B01/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '20549422368304181',
    fullFrontendId: 'Country_Corner/B01/Rack_02',
    ageInYears: 2.73972602739726,
    throughputTotal: 360800000.0,
    cyclesTotal: 902.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.34982505747473,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B01',
    unitFullId: 'Country_Corner/B01/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '67208029915131260',
    fullFrontendId: 'Country_Corner/B01/Rack_03',
    ageInYears: 2.73972602739726,
    throughputTotal: 360800000.0,
    cyclesTotal: 902.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.5856109092563,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B01',
    unitFullId: 'Country_Corner/B01/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '27545060227891593',
    fullFrontendId: 'Country_Corner/B01/Rack_04',
    ageInYears: 2.73972602739726,
    throughputTotal: 360800000.0,
    cyclesTotal: 902.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.8482133047485,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B01',
    unitFullId: 'Country_Corner/B01/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '60601306731649707',
    fullFrontendId: 'Country_Corner/B01/Rack_05',
    ageInYears: 2.73972602739726,
    throughputTotal: 360800000.0,
    cyclesTotal: 902.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.32105833540909,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B01',
    unitFullId: 'Country_Corner/B01/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '63123832139559368',
    fullFrontendId: 'Country_Corner/B01/Rack_06',
    ageInYears: 2.73972602739726,
    throughputTotal: 360800000.0,
    cyclesTotal: 902.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.32106326074134,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B01',
    unitFullId: 'Country_Corner/B01/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '41944926425762964',
    fullFrontendId: 'Country_Corner/B01/Rack_07',
    ageInYears: 2.73972602739726,
    throughputTotal: 360800000.0,
    cyclesTotal: 902.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.8650681924783,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B01',
    unitFullId: 'Country_Corner/B01/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '24405506703844224',
    fullFrontendId: 'Country_Corner/B01/Rack_08',
    ageInYears: 2.73972602739726,
    throughputTotal: 360800000.0,
    cyclesTotal: 902.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.62153476657197,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B01',
    unitFullId: 'Country_Corner/B01/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '42272127689711786',
    fullFrontendId: 'Country_Corner/B01/Rack_09',
    ageInYears: 2.73972602739726,
    throughputTotal: 360800000.0,
    cyclesTotal: 902.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.2504620320456,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B01',
    unitFullId: 'Country_Corner/B01/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '6471416015895949',
    fullFrontendId: 'Country_Corner/B01/Rack_10',
    ageInYears: 2.73972602739726,
    throughputTotal: 362000000.0,
    cyclesTotal: 905.0,
    sohPenaltyMax: 0.0,
    sohAccure: 84.0,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B01',
    unitFullId: 'Country_Corner/B01/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '53412654243085819',
    fullFrontendId: 'Country_Corner/B02/Rack_01',
    ageInYears: 2.73972602739726,
    throughputTotal: 357200000.0,
    cyclesTotal: 893.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.25227903998235,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B02',
    unitFullId: 'Country_Corner/B02/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '41132362186614864',
    fullFrontendId: 'Country_Corner/B02/Rack_02',
    ageInYears: 2.73972602739726,
    throughputTotal: 357200000.0,
    cyclesTotal: 893.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.25158542175501,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B02',
    unitFullId: 'Country_Corner/B02/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '200804506794335',
    fullFrontendId: 'Country_Corner/B02/Rack_03',
    ageInYears: 2.73972602739726,
    throughputTotal: 357200000.0,
    cyclesTotal: 893.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.4638930292959,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B02',
    unitFullId: 'Country_Corner/B02/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '3005189968530496',
    fullFrontendId: 'Country_Corner/B02/Rack_04',
    ageInYears: 2.73972602739726,
    throughputTotal: 357200000.0,
    cyclesTotal: 893.0,
    sohPenaltyMax: 0.0,
    sohAccure: 88.0,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B02',
    unitFullId: 'Country_Corner/B02/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '22183080308027674',
    fullFrontendId: 'Country_Corner/B02/Rack_05',
    ageInYears: 2.73972602739726,
    throughputTotal: 357200000.0,
    cyclesTotal: 893.0,
    sohPenaltyMax: 0.0,
    sohAccure: 84.87382899807218,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B02',
    unitFullId: 'Country_Corner/B02/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '33153032122014401',
    fullFrontendId: 'Country_Corner/B02/Rack_06',
    ageInYears: 2.73972602739726,
    throughputTotal: 357200000.0,
    cyclesTotal: 893.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.2226180890538,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B02',
    unitFullId: 'Country_Corner/B02/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '11384857325292251',
    fullFrontendId: 'Country_Corner/B02/Rack_07',
    ageInYears: 2.73972602739726,
    throughputTotal: 359200000.0,
    cyclesTotal: 898.0,
    sohPenaltyMax: 0.0,
    sohAccure: 84.0,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B02',
    unitFullId: 'Country_Corner/B02/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '53702617871982399',
    fullFrontendId: 'Country_Corner/B02/Rack_08',
    ageInYears: 2.73972602739726,
    throughputTotal: 359200000.0,
    cyclesTotal: 898.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.48557854760467,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B02',
    unitFullId: 'Country_Corner/B02/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '43313190410857714',
    fullFrontendId: 'Country_Corner/B02/Rack_09',
    ageInYears: 2.73972602739726,
    throughputTotal: 359200000.0,
    cyclesTotal: 898.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.11889712516972,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B02',
    unitFullId: 'Country_Corner/B02/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '49587895811009218',
    fullFrontendId: 'Country_Corner/B02/Rack_10',
    ageInYears: 2.73972602739726,
    throughputTotal: 359200000.0,
    cyclesTotal: 898.0,
    sohPenaltyMax: 0.0,
    sohAccure: 84.96761323742551,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B02',
    unitFullId: 'Country_Corner/B02/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '49243845264996471',
    fullFrontendId: 'Country_Corner/B03/Rack_01',
    ageInYears: 2.73972602739726,
    throughputTotal: 357600000.0,
    cyclesTotal: 894.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.83099897850256,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B03',
    unitFullId: 'Country_Corner/B03/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '47799741924237567',
    fullFrontendId: 'Country_Corner/B03/Rack_02',
    ageInYears: 2.73972602739726,
    throughputTotal: 357600000.0,
    cyclesTotal: 894.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.32357145768013,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B03',
    unitFullId: 'Country_Corner/B03/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '19546148844086505',
    fullFrontendId: 'Country_Corner/B03/Rack_03',
    ageInYears: 2.73972602739726,
    throughputTotal: 357600000.0,
    cyclesTotal: 894.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.41156280923246,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B03',
    unitFullId: 'Country_Corner/B03/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '12413274228929202',
    fullFrontendId: 'Country_Corner/B03/Rack_04',
    ageInYears: 2.73972602739726,
    throughputTotal: 357600000.0,
    cyclesTotal: 894.0,
    sohPenaltyMax: 0.0,
    sohAccure: 84.96387989196205,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B03',
    unitFullId: 'Country_Corner/B03/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '10193385709592867',
    fullFrontendId: 'Country_Corner/B03/Rack_05',
    ageInYears: 2.73972602739726,
    throughputTotal: 357600000.0,
    cyclesTotal: 894.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.22798953046853,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B03',
    unitFullId: 'Country_Corner/B03/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '27325543801546025',
    fullFrontendId: 'Country_Corner/B03/Rack_06',
    ageInYears: 2.73972602739726,
    throughputTotal: 357600000.0,
    cyclesTotal: 894.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.42458112473905,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B03',
    unitFullId: 'Country_Corner/B03/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '25491175176508835',
    fullFrontendId: 'Country_Corner/B03/Rack_07',
    ageInYears: 2.73972602739726,
    throughputTotal: 357600000.0,
    cyclesTotal: 894.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.0460062745994,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B03',
    unitFullId: 'Country_Corner/B03/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '50385604783138722',
    fullFrontendId: 'Country_Corner/B03/Rack_08',
    ageInYears: 2.73972602739726,
    throughputTotal: 357600000.0,
    cyclesTotal: 894.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.5040137533298,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B03',
    unitFullId: 'Country_Corner/B03/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '33421511769530802',
    fullFrontendId: 'Country_Corner/B03/Rack_09',
    ageInYears: 2.73972602739726,
    throughputTotal: 357600000.0,
    cyclesTotal: 894.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.21111274085045,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B03',
    unitFullId: 'Country_Corner/B03/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '29970670436018244',
    fullFrontendId: 'Country_Corner/B03/Rack_10',
    ageInYears: 2.73972602739726,
    throughputTotal: 357600000.0,
    cyclesTotal: 894.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.30379622288811,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B03',
    unitFullId: 'Country_Corner/B03/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '11057815505330630',
    fullFrontendId: 'Country_Corner/B04/Rack_01',
    ageInYears: 2.73972602739726,
    throughputTotal: 357600000.0,
    cyclesTotal: 894.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.21079236415727,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B04',
    unitFullId: 'Country_Corner/B04/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '9964012301718093',
    fullFrontendId: 'Country_Corner/B04/Rack_02',
    ageInYears: 2.73972602739726,
    throughputTotal: 357600000.0,
    cyclesTotal: 894.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.94698780317877,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B04',
    unitFullId: 'Country_Corner/B04/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '68692154953849428',
    fullFrontendId: 'Country_Corner/B04/Rack_03',
    ageInYears: 2.73972602739726,
    throughputTotal: 357600000.0,
    cyclesTotal: 894.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.38725518040471,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B04',
    unitFullId: 'Country_Corner/B04/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '27864213323333659',
    fullFrontendId: 'Country_Corner/B04/Rack_04',
    ageInYears: 2.73972602739726,
    throughputTotal: 357600000.0,
    cyclesTotal: 894.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.07399106913932,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B04',
    unitFullId: 'Country_Corner/B04/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '2251106242537921',
    fullFrontendId: 'Country_Corner/B04/Rack_05',
    ageInYears: 2.73972602739726,
    throughputTotal: 357600000.0,
    cyclesTotal: 894.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.63806782145706,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B04',
    unitFullId: 'Country_Corner/B04/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '42230967664824705',
    fullFrontendId: 'Country_Corner/B04/Rack_06',
    ageInYears: 2.73972602739726,
    throughputTotal: 357600000.0,
    cyclesTotal: 894.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.02505125283479,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B04',
    unitFullId: 'Country_Corner/B04/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '32398600054135596',
    fullFrontendId: 'Country_Corner/B04/Rack_07',
    ageInYears: 2.73972602739726,
    throughputTotal: 357600000.0,
    cyclesTotal: 894.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.45396342632752,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B04',
    unitFullId: 'Country_Corner/B04/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '32228836347571270',
    fullFrontendId: 'Country_Corner/B04/Rack_08',
    ageInYears: 2.73972602739726,
    throughputTotal: 357600000.0,
    cyclesTotal: 894.0,
    sohPenaltyMax: 0.0,
    sohAccure: 84.80340331066216,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B04',
    unitFullId: 'Country_Corner/B04/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '43743256505231184',
    fullFrontendId: 'Country_Corner/B04/Rack_09',
    ageInYears: 2.73972602739726,
    throughputTotal: 357600000.0,
    cyclesTotal: 894.0,
    sohPenaltyMax: 0.0,
    sohAccure: 84.99284853315656,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B04',
    unitFullId: 'Country_Corner/B04/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '50371792209163583',
    fullFrontendId: 'Country_Corner/B04/Rack_10',
    ageInYears: 2.73972602739726,
    throughputTotal: 357600000.0,
    cyclesTotal: 894.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.45036271858683,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B04',
    unitFullId: 'Country_Corner/B04/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '25873446975477286',
    fullFrontendId: 'Country_Corner/B05/Rack_01',
    ageInYears: 2.73972602739726,
    throughputTotal: 357600000.0,
    cyclesTotal: 894.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.61284432182471,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B05',
    unitFullId: 'Country_Corner/B05/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '15324756511501699',
    fullFrontendId: 'Country_Corner/B05/Rack_02',
    ageInYears: 2.73972602739726,
    throughputTotal: 357600000.0,
    cyclesTotal: 894.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.44271483218309,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B05',
    unitFullId: 'Country_Corner/B05/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '12842385906561425',
    fullFrontendId: 'Country_Corner/B05/Rack_03',
    ageInYears: 2.73972602739726,
    throughputTotal: 357600000.0,
    cyclesTotal: 894.0,
    sohPenaltyMax: 0.0,
    sohAccure: 86.0,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B05',
    unitFullId: 'Country_Corner/B05/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '6754493798219001',
    fullFrontendId: 'Country_Corner/B05/Rack_04',
    ageInYears: 2.73972602739726,
    throughputTotal: 359600000.0,
    cyclesTotal: 899.0,
    sohPenaltyMax: 0.0,
    sohAccure: 86.0,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B05',
    unitFullId: 'Country_Corner/B05/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '46986623740661229',
    fullFrontendId: 'Country_Corner/B05/Rack_05',
    ageInYears: 2.73972602739726,
    throughputTotal: 359600000.0,
    cyclesTotal: 899.0,
    sohPenaltyMax: 0.0,
    sohAccure: 84.94774775071586,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B05',
    unitFullId: 'Country_Corner/B05/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '34451422262265380',
    fullFrontendId: 'Country_Corner/B05/Rack_06',
    ageInYears: 2.73972602739726,
    throughputTotal: 359600000.0,
    cyclesTotal: 899.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.17535108530768,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B05',
    unitFullId: 'Country_Corner/B05/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '51228206435257463',
    fullFrontendId: 'Country_Corner/B05/Rack_07',
    ageInYears: 2.73972602739726,
    throughputTotal: 359600000.0,
    cyclesTotal: 899.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.25311271653815,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B05',
    unitFullId: 'Country_Corner/B05/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '60935478022470524',
    fullFrontendId: 'Country_Corner/B05/Rack_08',
    ageInYears: 2.73972602739726,
    throughputTotal: 359600000.0,
    cyclesTotal: 899.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.70844101569176,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B05',
    unitFullId: 'Country_Corner/B05/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '47899254095945171',
    fullFrontendId: 'Country_Corner/B05/Rack_09',
    ageInYears: 2.73972602739726,
    throughputTotal: 359600000.0,
    cyclesTotal: 899.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.49438983469663,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B05',
    unitFullId: 'Country_Corner/B05/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '41766947065356657',
    fullFrontendId: 'Country_Corner/B05/Rack_10',
    ageInYears: 2.73972602739726,
    throughputTotal: 359600000.0,
    cyclesTotal: 899.0,
    sohPenaltyMax: 0.0,
    sohAccure: 84.86239230121727,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B05',
    unitFullId: 'Country_Corner/B05/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '5989054454777011',
    fullFrontendId: 'Country_Corner/B06/Rack_01',
    ageInYears: 2.73972602739726,
    throughputTotal: 359600000.0,
    cyclesTotal: 899.0,
    sohPenaltyMax: 0.0,
    sohAccure: 86.0,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B06',
    unitFullId: 'Country_Corner/B06/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '61595418260241589',
    fullFrontendId: 'Country_Corner/B06/Rack_02',
    ageInYears: 2.73972602739726,
    throughputTotal: 359600000.0,
    cyclesTotal: 899.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.2757796637012,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B06',
    unitFullId: 'Country_Corner/B06/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '31987574562642903',
    fullFrontendId: 'Country_Corner/B06/Rack_03',
    ageInYears: 2.73972602739726,
    throughputTotal: 359600000.0,
    cyclesTotal: 899.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.1882277477343,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B06',
    unitFullId: 'Country_Corner/B06/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '12499268189333681',
    fullFrontendId: 'Country_Corner/B06/Rack_04',
    ageInYears: 2.73972602739726,
    throughputTotal: 360400000.0,
    cyclesTotal: 901.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.0,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B06',
    unitFullId: 'Country_Corner/B06/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '34272712166528836',
    fullFrontendId: 'Country_Corner/B06/Rack_05',
    ageInYears: 2.73972602739726,
    throughputTotal: 360400000.0,
    cyclesTotal: 901.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.70060420457487,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B06',
    unitFullId: 'Country_Corner/B06/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '53228867100884859',
    fullFrontendId: 'Country_Corner/B06/Rack_06',
    ageInYears: 2.73972602739726,
    throughputTotal: 360400000.0,
    cyclesTotal: 901.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.67068838356096,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B06',
    unitFullId: 'Country_Corner/B06/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '52439835487991639',
    fullFrontendId: 'Country_Corner/B06/Rack_07',
    ageInYears: 2.73972602739726,
    throughputTotal: 360400000.0,
    cyclesTotal: 901.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.1395390908593,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B06',
    unitFullId: 'Country_Corner/B06/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '52458105774515491',
    fullFrontendId: 'Country_Corner/B06/Rack_08',
    ageInYears: 2.73972602739726,
    throughputTotal: 360400000.0,
    cyclesTotal: 901.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.29854063507072,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B06',
    unitFullId: 'Country_Corner/B06/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '15939649511646368',
    fullFrontendId: 'Country_Corner/B06/Rack_09',
    ageInYears: 2.73972602739726,
    throughputTotal: 360400000.0,
    cyclesTotal: 901.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.49068337724717,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B06',
    unitFullId: 'Country_Corner/B06/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '18133567724010800',
    fullFrontendId: 'Country_Corner/B06/Rack_10',
    ageInYears: 2.73972602739726,
    throughputTotal: 360400000.0,
    cyclesTotal: 901.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.6839678859628,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B06',
    unitFullId: 'Country_Corner/B06/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '9989473834664962',
    fullFrontendId: 'Country_Corner/B07/Rack_01',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.2475520764725,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B07',
    unitFullId: 'Country_Corner/B07/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '69618346777589466',
    fullFrontendId: 'Country_Corner/B07/Rack_02',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.33560665482695,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B07',
    unitFullId: 'Country_Corner/B07/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '14128602983920693',
    fullFrontendId: 'Country_Corner/B07/Rack_03',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.05940385562428,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B07',
    unitFullId: 'Country_Corner/B07/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '32892454087772485',
    fullFrontendId: 'Country_Corner/B07/Rack_04',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.03244236060189,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B07',
    unitFullId: 'Country_Corner/B07/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '63377333619320009',
    fullFrontendId: 'Country_Corner/B07/Rack_05',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.63506209454435,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B07',
    unitFullId: 'Country_Corner/B07/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '35260018520653022',
    fullFrontendId: 'Country_Corner/B07/Rack_06',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.79817635639733,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B07',
    unitFullId: 'Country_Corner/B07/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '3665309423788960',
    fullFrontendId: 'Country_Corner/B07/Rack_07',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.36970131135199,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B07',
    unitFullId: 'Country_Corner/B07/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '15352581004808595',
    fullFrontendId: 'Country_Corner/B07/Rack_08',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.6923642171937,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B07',
    unitFullId: 'Country_Corner/B07/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '35916998317933242',
    fullFrontendId: 'Country_Corner/B07/Rack_09',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.49979515534038,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B07',
    unitFullId: 'Country_Corner/B07/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '32872391906993377',
    fullFrontendId: 'Country_Corner/B07/Rack_10',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.19776842144455,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B07',
    unitFullId: 'Country_Corner/B07/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '64544906727223905',
    fullFrontendId: 'Country_Corner/B08/Rack_01',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.49972302947862,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B08',
    unitFullId: 'Country_Corner/B08/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '23152343014322097',
    fullFrontendId: 'Country_Corner/B08/Rack_02',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.85271531776588,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B08',
    unitFullId: 'Country_Corner/B08/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '3509739286086225',
    fullFrontendId: 'Country_Corner/B08/Rack_03',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.38055653609311,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B08',
    unitFullId: 'Country_Corner/B08/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '13317774037895696',
    fullFrontendId: 'Country_Corner/B08/Rack_04',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.86069744457029,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B08',
    unitFullId: 'Country_Corner/B08/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '57506560893055939',
    fullFrontendId: 'Country_Corner/B08/Rack_05',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 84.60538081659917,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B08',
    unitFullId: 'Country_Corner/B08/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '54611592107022391',
    fullFrontendId: 'Country_Corner/B08/Rack_06',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.63787509913865,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B08',
    unitFullId: 'Country_Corner/B08/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '68194431705816823',
    fullFrontendId: 'Country_Corner/B08/Rack_07',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.41741846829754,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B08',
    unitFullId: 'Country_Corner/B08/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '65342725437198548',
    fullFrontendId: 'Country_Corner/B08/Rack_08',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.30160214268633,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B08',
    unitFullId: 'Country_Corner/B08/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '8973983127750483',
    fullFrontendId: 'Country_Corner/B08/Rack_09',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.41883258078674,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B08',
    unitFullId: 'Country_Corner/B08/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '9163541306821944',
    fullFrontendId: 'Country_Corner/B08/Rack_10',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 84.79503367344583,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B08',
    unitFullId: 'Country_Corner/B08/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '61004656969650268',
    fullFrontendId: 'Country_Corner/B09/Rack_01',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.32540278147484,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B09',
    unitFullId: 'Country_Corner/B09/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '32584793640122762',
    fullFrontendId: 'Country_Corner/B09/Rack_02',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.49843811927961,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B09',
    unitFullId: 'Country_Corner/B09/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '59449140925314565',
    fullFrontendId: 'Country_Corner/B09/Rack_03',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.83467256124855,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B09',
    unitFullId: 'Country_Corner/B09/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '68920896432152338',
    fullFrontendId: 'Country_Corner/B09/Rack_04',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.235823282344,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B09',
    unitFullId: 'Country_Corner/B09/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '46790268423753599',
    fullFrontendId: 'Country_Corner/B09/Rack_05',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.14875626695813,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B09',
    unitFullId: 'Country_Corner/B09/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '37874475004350576',
    fullFrontendId: 'Country_Corner/B09/Rack_06',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.24077723475074,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B09',
    unitFullId: 'Country_Corner/B09/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '2958847841157008',
    fullFrontendId: 'Country_Corner/B09/Rack_07',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.66592498313672,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B09',
    unitFullId: 'Country_Corner/B09/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '26350145115484613',
    fullFrontendId: 'Country_Corner/B09/Rack_08',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.489929680724,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B09',
    unitFullId: 'Country_Corner/B09/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '32718999393037227',
    fullFrontendId: 'Country_Corner/B09/Rack_09',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.23237628669598,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B09',
    unitFullId: 'Country_Corner/B09/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '50677494698974635',
    fullFrontendId: 'Country_Corner/B09/Rack_10',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.5452845777601,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B09',
    unitFullId: 'Country_Corner/B09/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '785503921293096',
    fullFrontendId: 'Country_Corner/B10/Rack_01',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.4204276126305,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B10',
    unitFullId: 'Country_Corner/B10/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '24203669966234050',
    fullFrontendId: 'Country_Corner/B10/Rack_02',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.68189784498595,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B10',
    unitFullId: 'Country_Corner/B10/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '25429773579953858',
    fullFrontendId: 'Country_Corner/B10/Rack_03',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.18068841966289,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B10',
    unitFullId: 'Country_Corner/B10/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '32656801140191935',
    fullFrontendId: 'Country_Corner/B10/Rack_04',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.29300570384676,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B10',
    unitFullId: 'Country_Corner/B10/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '33086645431136950',
    fullFrontendId: 'Country_Corner/B10/Rack_05',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.27367190188644,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B10',
    unitFullId: 'Country_Corner/B10/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '44821244190917697',
    fullFrontendId: 'Country_Corner/B10/Rack_06',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 84.95224986338646,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B10',
    unitFullId: 'Country_Corner/B10/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '15751082509800804',
    fullFrontendId: 'Country_Corner/B10/Rack_07',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.48014043094547,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B10',
    unitFullId: 'Country_Corner/B10/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '14178622165374584',
    fullFrontendId: 'Country_Corner/B10/Rack_08',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 86.0,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B10',
    unitFullId: 'Country_Corner/B10/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '17881726359928172',
    fullFrontendId: 'Country_Corner/B10/Rack_09',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.39283838481883,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B10',
    unitFullId: 'Country_Corner/B10/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '32809988975118168',
    fullFrontendId: 'Country_Corner/B10/Rack_10',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.32092820781355,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B10',
    unitFullId: 'Country_Corner/B10/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '23323314879478550',
    fullFrontendId: 'Country_Corner/B11/Rack_01',
    ageInYears: 2.73972602739726,
    throughputTotal: 364000000.0,
    cyclesTotal: 910.0,
    sohPenaltyMax: 0.0,
    sohAccure: 84.96669312521097,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B11',
    unitFullId: 'Country_Corner/B11/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '61365916912849309',
    fullFrontendId: 'Country_Corner/B11/Rack_02',
    ageInYears: 2.73972602739726,
    throughputTotal: 364000000.0,
    cyclesTotal: 910.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.26511075099648,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B11',
    unitFullId: 'Country_Corner/B11/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '23468523451455008',
    fullFrontendId: 'Country_Corner/B11/Rack_03',
    ageInYears: 2.73972602739726,
    throughputTotal: 364000000.0,
    cyclesTotal: 910.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.28848999286807,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B11',
    unitFullId: 'Country_Corner/B11/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '829221139101683',
    fullFrontendId: 'Country_Corner/B11/Rack_04',
    ageInYears: 2.73972602739726,
    throughputTotal: 364000000.0,
    cyclesTotal: 910.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.15062116705961,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B11',
    unitFullId: 'Country_Corner/B11/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '8614138290846856',
    fullFrontendId: 'Country_Corner/B11/Rack_05',
    ageInYears: 2.73972602739726,
    throughputTotal: 364000000.0,
    cyclesTotal: 910.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.3429186343263,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B11',
    unitFullId: 'Country_Corner/B11/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '48818031772887542',
    fullFrontendId: 'Country_Corner/B11/Rack_06',
    ageInYears: 2.73972602739726,
    throughputTotal: 364000000.0,
    cyclesTotal: 910.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.51251960487045,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B11',
    unitFullId: 'Country_Corner/B11/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '20465382959444694',
    fullFrontendId: 'Country_Corner/B11/Rack_07',
    ageInYears: 2.73972602739726,
    throughputTotal: 364000000.0,
    cyclesTotal: 910.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.95716011818925,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B11',
    unitFullId: 'Country_Corner/B11/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '7332170133676183',
    fullFrontendId: 'Country_Corner/B11/Rack_08',
    ageInYears: 2.73972602739726,
    throughputTotal: 364000000.0,
    cyclesTotal: 910.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.44367769167565,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B11',
    unitFullId: 'Country_Corner/B11/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '67551768505398407',
    fullFrontendId: 'Country_Corner/B11/Rack_09',
    ageInYears: 2.73972602739726,
    throughputTotal: 364000000.0,
    cyclesTotal: 910.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.46856946504292,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B11',
    unitFullId: 'Country_Corner/B11/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '21073265830312646',
    fullFrontendId: 'Country_Corner/B11/Rack_10',
    ageInYears: 2.73972602739726,
    throughputTotal: 364000000.0,
    cyclesTotal: 910.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.36897057309625,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B11',
    unitFullId: 'Country_Corner/B11/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '18012315565896238',
    fullFrontendId: 'Country_Corner/B12/Rack_01',
    ageInYears: 2.73972602739726,
    throughputTotal: 364000000.0,
    cyclesTotal: 910.0,
    sohPenaltyMax: 0.0,
    sohAccure: 84.81567298323638,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B12',
    unitFullId: 'Country_Corner/B12/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '4096745221330263',
    fullFrontendId: 'Country_Corner/B12/Rack_02',
    ageInYears: 2.73972602739726,
    throughputTotal: 364000000.0,
    cyclesTotal: 910.0,
    sohPenaltyMax: 0.0,
    sohAccure: 86.0,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B12',
    unitFullId: 'Country_Corner/B12/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '14939940098146335',
    fullFrontendId: 'Country_Corner/B12/Rack_03',
    ageInYears: 2.73972602739726,
    throughputTotal: 364000000.0,
    cyclesTotal: 910.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.4093734108084,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B12',
    unitFullId: 'Country_Corner/B12/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '43096600658243782',
    fullFrontendId: 'Country_Corner/B12/Rack_04',
    ageInYears: 2.73972602739726,
    throughputTotal: 364000000.0,
    cyclesTotal: 910.0,
    sohPenaltyMax: 0.0,
    sohAccure: 86.13027698157168,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B12',
    unitFullId: 'Country_Corner/B12/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '46968088649331818',
    fullFrontendId: 'Country_Corner/B12/Rack_05',
    ageInYears: 2.73972602739726,
    throughputTotal: 364000000.0,
    cyclesTotal: 910.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.33359605839176,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B12',
    unitFullId: 'Country_Corner/B12/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '6056484481157065',
    fullFrontendId: 'Country_Corner/B12/Rack_06',
    ageInYears: 2.73972602739726,
    throughputTotal: 364000000.0,
    cyclesTotal: 910.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.48176855052618,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B12',
    unitFullId: 'Country_Corner/B12/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '5593354097500761',
    fullFrontendId: 'Country_Corner/B12/Rack_07',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 86.0,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B12',
    unitFullId: 'Country_Corner/B12/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '11827113576427829',
    fullFrontendId: 'Country_Corner/B12/Rack_08',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.04070093654023,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B12',
    unitFullId: 'Country_Corner/B12/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '69727619634080034',
    fullFrontendId: 'Country_Corner/B12/Rack_09',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.7341511921806,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B12',
    unitFullId: 'Country_Corner/B12/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '15219950701611155',
    fullFrontendId: 'Country_Corner/B12/Rack_10',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.61688425763212,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B12',
    unitFullId: 'Country_Corner/B12/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '46452454989978560',
    fullFrontendId: 'Country_Corner/B13/Rack_01',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.628613931939,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B13',
    unitFullId: 'Country_Corner/B13/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '69006296838680225',
    fullFrontendId: 'Country_Corner/B13/Rack_02',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.11848811138768,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B13',
    unitFullId: 'Country_Corner/B13/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '63998850703293741',
    fullFrontendId: 'Country_Corner/B13/Rack_03',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.81214264110692,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B13',
    unitFullId: 'Country_Corner/B13/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '46949240297145001',
    fullFrontendId: 'Country_Corner/B13/Rack_04',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 84.97074902898841,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B13',
    unitFullId: 'Country_Corner/B13/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '399911267441666',
    fullFrontendId: 'Country_Corner/B13/Rack_05',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.56736147596618,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B13',
    unitFullId: 'Country_Corner/B13/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '48619095513868517',
    fullFrontendId: 'Country_Corner/B13/Rack_06',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 86.04844103556908,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B13',
    unitFullId: 'Country_Corner/B13/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '34768599284165404',
    fullFrontendId: 'Country_Corner/B13/Rack_07',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.0941434502869,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B13',
    unitFullId: 'Country_Corner/B13/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '56653590783418914',
    fullFrontendId: 'Country_Corner/B13/Rack_08',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.22141502894526,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B13',
    unitFullId: 'Country_Corner/B13/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '69842489705839361',
    fullFrontendId: 'Country_Corner/B13/Rack_09',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.42119975735238,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B13',
    unitFullId: 'Country_Corner/B13/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '57550393130509657',
    fullFrontendId: 'Country_Corner/B13/Rack_10',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.24026165159124,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B13',
    unitFullId: 'Country_Corner/B13/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '45297514382031054',
    fullFrontendId: 'Country_Corner/B14/Rack_01',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 84.92610531850626,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B14',
    unitFullId: 'Country_Corner/B14/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '62503218827957649',
    fullFrontendId: 'Country_Corner/B14/Rack_02',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.4118732402679,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B14',
    unitFullId: 'Country_Corner/B14/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '29245221879371902',
    fullFrontendId: 'Country_Corner/B14/Rack_03',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.07261323370827,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B14',
    unitFullId: 'Country_Corner/B14/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '2050947959828042',
    fullFrontendId: 'Country_Corner/B14/Rack_04',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.53338207701665,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B14',
    unitFullId: 'Country_Corner/B14/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '67770605905027679',
    fullFrontendId: 'Country_Corner/B14/Rack_05',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.11547707755595,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B14',
    unitFullId: 'Country_Corner/B14/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '25632963672790656',
    fullFrontendId: 'Country_Corner/B14/Rack_06',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.85628466933136,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B14',
    unitFullId: 'Country_Corner/B14/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '25111777456411057',
    fullFrontendId: 'Country_Corner/B14/Rack_07',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.15632836012522,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B14',
    unitFullId: 'Country_Corner/B14/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '776486031583367',
    fullFrontendId: 'Country_Corner/B14/Rack_08',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.2946858929644,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B14',
    unitFullId: 'Country_Corner/B14/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '9185293464686176',
    fullFrontendId: 'Country_Corner/B14/Rack_09',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.63535951303699,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B14',
    unitFullId: 'Country_Corner/B14/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '20307605857058898',
    fullFrontendId: 'Country_Corner/B14/Rack_10',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.0220450528959,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B14',
    unitFullId: 'Country_Corner/B14/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '53051536248505854',
    fullFrontendId: 'Country_Corner/B15/Rack_01',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.45954232820733,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B15',
    unitFullId: 'Country_Corner/B15/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '16613706757810192',
    fullFrontendId: 'Country_Corner/B15/Rack_02',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.78344717411082,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B15',
    unitFullId: 'Country_Corner/B15/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '62620663632847641',
    fullFrontendId: 'Country_Corner/B15/Rack_03',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 84.90905937745772,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B15',
    unitFullId: 'Country_Corner/B15/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '10689697607974890',
    fullFrontendId: 'Country_Corner/B15/Rack_04',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.44669450538578,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B15',
    unitFullId: 'Country_Corner/B15/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '55330563590153514',
    fullFrontendId: 'Country_Corner/B15/Rack_05',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.46926918610062,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B15',
    unitFullId: 'Country_Corner/B15/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '9700019772627367',
    fullFrontendId: 'Country_Corner/B15/Rack_06',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.62585120935928,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B15',
    unitFullId: 'Country_Corner/B15/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '70032675825587218',
    fullFrontendId: 'Country_Corner/B15/Rack_07',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.02021913456267,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B15',
    unitFullId: 'Country_Corner/B15/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '2116836727674663',
    fullFrontendId: 'Country_Corner/B15/Rack_08',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 84.9951673639008,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B15',
    unitFullId: 'Country_Corner/B15/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '18915650254211359',
    fullFrontendId: 'Country_Corner/B15/Rack_09',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.54788681751116,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B15',
    unitFullId: 'Country_Corner/B15/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '64661473704722937',
    fullFrontendId: 'Country_Corner/B15/Rack_10',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.48039974979605,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B15',
    unitFullId: 'Country_Corner/B15/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '49108634764414873',
    fullFrontendId: 'Country_Corner/B16/Rack_01',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.46645220292986,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B16',
    unitFullId: 'Country_Corner/B16/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '35889711615253138',
    fullFrontendId: 'Country_Corner/B16/Rack_02',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.49523881067519,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B16',
    unitFullId: 'Country_Corner/B16/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '12413331974127915',
    fullFrontendId: 'Country_Corner/B16/Rack_03',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.0,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B16',
    unitFullId: 'Country_Corner/B16/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '67830636093593716',
    fullFrontendId: 'Country_Corner/B16/Rack_04',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.4609804569744,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B16',
    unitFullId: 'Country_Corner/B16/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '18592466168668586',
    fullFrontendId: 'Country_Corner/B16/Rack_05',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.4792260898157,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B16',
    unitFullId: 'Country_Corner/B16/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '17858253888497353',
    fullFrontendId: 'Country_Corner/B16/Rack_06',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.17699892241818,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B16',
    unitFullId: 'Country_Corner/B16/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '71012265472545572',
    fullFrontendId: 'Country_Corner/B16/Rack_07',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.95103670116951,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B16',
    unitFullId: 'Country_Corner/B16/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '14465267306586943',
    fullFrontendId: 'Country_Corner/B16/Rack_08',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.53345422409963,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B16',
    unitFullId: 'Country_Corner/B16/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '30706446729201059',
    fullFrontendId: 'Country_Corner/B16/Rack_09',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.0339132986653,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B16',
    unitFullId: 'Country_Corner/B16/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '4820068605217853',
    fullFrontendId: 'Country_Corner/B16/Rack_10',
    ageInYears: 2.73972602739726,
    throughputTotal: 364000000.0,
    cyclesTotal: 910.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.0,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B16',
    unitFullId: 'Country_Corner/B16/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '52142253395025605',
    fullFrontendId: 'Country_Corner/B17/Rack_01',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.0988998467579,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B17',
    unitFullId: 'Country_Corner/B17/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '20333699900798398',
    fullFrontendId: 'Country_Corner/B17/Rack_02',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.62742972894883,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B17',
    unitFullId: 'Country_Corner/B17/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '61698682213406551',
    fullFrontendId: 'Country_Corner/B17/Rack_03',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.73888302152831,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B17',
    unitFullId: 'Country_Corner/B17/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '22258116000080408',
    fullFrontendId: 'Country_Corner/B17/Rack_04',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.14509965232058,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B17',
    unitFullId: 'Country_Corner/B17/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '2687068079496498',
    fullFrontendId: 'Country_Corner/B17/Rack_05',
    ageInYears: 2.73972602739726,
    throughputTotal: 358800000.0,
    cyclesTotal: 897.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.0,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B17',
    unitFullId: 'Country_Corner/B17/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '4090001669242293',
    fullFrontendId: 'Country_Corner/B17/Rack_06',
    ageInYears: 2.73972602739726,
    throughputTotal: 363200000.0,
    cyclesTotal: 908.0,
    sohPenaltyMax: 0.0,
    sohAccure: 86.0,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B17',
    unitFullId: 'Country_Corner/B17/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '21750137908642234',
    fullFrontendId: 'Country_Corner/B17/Rack_07',
    ageInYears: 2.73972602739726,
    throughputTotal: 363200000.0,
    cyclesTotal: 908.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.63792239582445,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B17',
    unitFullId: 'Country_Corner/B17/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '7497721837416599',
    fullFrontendId: 'Country_Corner/B17/Rack_08',
    ageInYears: 2.73972602739726,
    throughputTotal: 363200000.0,
    cyclesTotal: 908.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.96034224262227,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B17',
    unitFullId: 'Country_Corner/B17/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '67536427088638350',
    fullFrontendId: 'Country_Corner/B17/Rack_09',
    ageInYears: 2.73972602739726,
    throughputTotal: 363200000.0,
    cyclesTotal: 908.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.31768791302524,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B17',
    unitFullId: 'Country_Corner/B17/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '56988802654745276',
    fullFrontendId: 'Country_Corner/B17/Rack_10',
    ageInYears: 2.73972602739726,
    throughputTotal: 363200000.0,
    cyclesTotal: 908.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.16518349851884,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B17',
    unitFullId: 'Country_Corner/B17/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '70853358094367588',
    fullFrontendId: 'Country_Corner/B18/Rack_01',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.12445001893843,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B18',
    unitFullId: 'Country_Corner/B18/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '22159651839929015',
    fullFrontendId: 'Country_Corner/B18/Rack_02',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.14656126233646,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B18',
    unitFullId: 'Country_Corner/B18/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '61807720426445642',
    fullFrontendId: 'Country_Corner/B18/Rack_03',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.36817383500185,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B18',
    unitFullId: 'Country_Corner/B18/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '41149068504866849',
    fullFrontendId: 'Country_Corner/B18/Rack_04',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.49364994027108,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B18',
    unitFullId: 'Country_Corner/B18/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '35872618282645831',
    fullFrontendId: 'Country_Corner/B18/Rack_05',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.4743115876251,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B18',
    unitFullId: 'Country_Corner/B18/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '37450924689339264',
    fullFrontendId: 'Country_Corner/B18/Rack_06',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.6394593225369,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B18',
    unitFullId: 'Country_Corner/B18/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '57970417146406091',
    fullFrontendId: 'Country_Corner/B18/Rack_07',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.39520491538947,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B18',
    unitFullId: 'Country_Corner/B18/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '56908883118135827',
    fullFrontendId: 'Country_Corner/B18/Rack_08',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.82736457097329,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B18',
    unitFullId: 'Country_Corner/B18/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '66615624213342415',
    fullFrontendId: 'Country_Corner/B18/Rack_09',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.3119072978547,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B18',
    unitFullId: 'Country_Corner/B18/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '65081736682430764',
    fullFrontendId: 'Country_Corner/B18/Rack_10',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 86.20735509780297,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B18',
    unitFullId: 'Country_Corner/B18/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '41016897833360183',
    fullFrontendId: 'Country_Corner/B19/Rack_01',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.5790045521556,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B19',
    unitFullId: 'Country_Corner/B19/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '59330341324369333',
    fullFrontendId: 'Country_Corner/B19/Rack_02',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.1341570809012,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B19',
    unitFullId: 'Country_Corner/B19/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '40970096715439578',
    fullFrontendId: 'Country_Corner/B19/Rack_03',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.07003659840775,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B19',
    unitFullId: 'Country_Corner/B19/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '41922314307811273',
    fullFrontendId: 'Country_Corner/B19/Rack_04',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.53604607239905,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B19',
    unitFullId: 'Country_Corner/B19/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '2026255838254836',
    fullFrontendId: 'Country_Corner/B19/Rack_05',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.0,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B19',
    unitFullId: 'Country_Corner/B19/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '51865357333988480',
    fullFrontendId: 'Country_Corner/B19/Rack_06',
    ageInYears: 2.73972602739726,
    throughputTotal: 361600000.0,
    cyclesTotal: 904.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.60550449605373,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B19',
    unitFullId: 'Country_Corner/B19/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '6277603696836004',
    fullFrontendId: 'Country_Corner/B19/Rack_07',
    ageInYears: 2.73972602739726,
    throughputTotal: 357600000.0,
    cyclesTotal: 894.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.0,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B19',
    unitFullId: 'Country_Corner/B19/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '39160585113044302',
    fullFrontendId: 'Country_Corner/B19/Rack_08',
    ageInYears: 2.73972602739726,
    throughputTotal: 357600000.0,
    cyclesTotal: 894.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.36945567402903,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B19',
    unitFullId: 'Country_Corner/B19/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '15525746307216519',
    fullFrontendId: 'Country_Corner/B19/Rack_09',
    ageInYears: 2.73972602739726,
    throughputTotal: 357600000.0,
    cyclesTotal: 894.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.13726623240557,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B19',
    unitFullId: 'Country_Corner/B19/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '13750238921869415',
    fullFrontendId: 'Country_Corner/B19/Rack_10',
    ageInYears: 2.73972602739726,
    throughputTotal: 357600000.0,
    cyclesTotal: 894.0,
    sohPenaltyMax: 0.0,
    sohAccure: 84.93685018042034,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B19',
    unitFullId: 'Country_Corner/B19/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '573834764319158',
    fullFrontendId: 'Country_Corner/B20/Rack_01',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.25734986220598,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B20',
    unitFullId: 'Country_Corner/B20/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '15649704207484200',
    fullFrontendId: 'Country_Corner/B20/Rack_02',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.64822398612313,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B20',
    unitFullId: 'Country_Corner/B20/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '66087345753916469',
    fullFrontendId: 'Country_Corner/B20/Rack_03',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.45553247106515,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B20',
    unitFullId: 'Country_Corner/B20/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '34937527639391239',
    fullFrontendId: 'Country_Corner/B20/Rack_04',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.0175827142125,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B20',
    unitFullId: 'Country_Corner/B20/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '17562350934547220',
    fullFrontendId: 'Country_Corner/B20/Rack_05',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.44325862558145,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B20',
    unitFullId: 'Country_Corner/B20/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '20795102937643068',
    fullFrontendId: 'Country_Corner/B20/Rack_06',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.50689956174475,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B20',
    unitFullId: 'Country_Corner/B20/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '1625159942916716',
    fullFrontendId: 'Country_Corner/B20/Rack_07',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.12614711696575,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B20',
    unitFullId: 'Country_Corner/B20/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '29545554138899483',
    fullFrontendId: 'Country_Corner/B20/Rack_08',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.43742187960976,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B20',
    unitFullId: 'Country_Corner/B20/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '35814042208166959',
    fullFrontendId: 'Country_Corner/B20/Rack_09',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.4087669633599,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B20',
    unitFullId: 'Country_Corner/B20/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '51261903590874457',
    fullFrontendId: 'Country_Corner/B20/Rack_10',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.04841325847691,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B20',
    unitFullId: 'Country_Corner/B20/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '52187848566817573',
    fullFrontendId: 'Country_Corner/B21/Rack_01',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.49864055593058,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B21',
    unitFullId: 'Country_Corner/B21/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '27170204668173644',
    fullFrontendId: 'Country_Corner/B21/Rack_02',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.55953970573657,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B21',
    unitFullId: 'Country_Corner/B21/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '6204771740522162',
    fullFrontendId: 'Country_Corner/B21/Rack_03',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.71621972077868,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B21',
    unitFullId: 'Country_Corner/B21/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '20906450787144733',
    fullFrontendId: 'Country_Corner/B21/Rack_04',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.70744496343656,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B21',
    unitFullId: 'Country_Corner/B21/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '56701931486759686',
    fullFrontendId: 'Country_Corner/B21/Rack_05',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 84.97800353743897,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B21',
    unitFullId: 'Country_Corner/B21/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '39562889667935613',
    fullFrontendId: 'Country_Corner/B21/Rack_06',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.10995683585156,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B21',
    unitFullId: 'Country_Corner/B21/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '53494161462184094',
    fullFrontendId: 'Country_Corner/B21/Rack_07',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.54581492798869,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B21',
    unitFullId: 'Country_Corner/B21/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '34966689709591649',
    fullFrontendId: 'Country_Corner/B21/Rack_08',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.54544013309976,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B21',
    unitFullId: 'Country_Corner/B21/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '31046135398117221',
    fullFrontendId: 'Country_Corner/B21/Rack_09',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.5458186537179,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B21',
    unitFullId: 'Country_Corner/B21/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '39957277760540041',
    fullFrontendId: 'Country_Corner/B21/Rack_10',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 86.54712379502251,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B21',
    unitFullId: 'Country_Corner/B21/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '9183437896062067',
    fullFrontendId: 'Country_Corner/B22/Rack_01',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.56257150103404,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B22',
    unitFullId: 'Country_Corner/B22/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '61750720480460367',
    fullFrontendId: 'Country_Corner/B22/Rack_02',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.0,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B22',
    unitFullId: 'Country_Corner/B22/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '5009413002640889',
    fullFrontendId: 'Country_Corner/B22/Rack_03',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.67750487687405,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B22',
    unitFullId: 'Country_Corner/B22/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '10439670912067822',
    fullFrontendId: 'Country_Corner/B22/Rack_04',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.58672172321783,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B22',
    unitFullId: 'Country_Corner/B22/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '37633342627217530',
    fullFrontendId: 'Country_Corner/B22/Rack_05',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.29672357443398,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B22',
    unitFullId: 'Country_Corner/B22/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '15652258410448933',
    fullFrontendId: 'Country_Corner/B22/Rack_06',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.61899511397408,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B22',
    unitFullId: 'Country_Corner/B22/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '29853818218223332',
    fullFrontendId: 'Country_Corner/B22/Rack_07',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.15945678346482,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B22',
    unitFullId: 'Country_Corner/B22/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '62893054815165414',
    fullFrontendId: 'Country_Corner/B22/Rack_08',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.32025876580408,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B22',
    unitFullId: 'Country_Corner/B22/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '10163183405473968',
    fullFrontendId: 'Country_Corner/B22/Rack_09',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.24569528347736,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B22',
    unitFullId: 'Country_Corner/B22/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '49400842981247887',
    fullFrontendId: 'Country_Corner/B22/Rack_10',
    ageInYears: 2.73972602739726,
    throughputTotal: 357600000.0,
    cyclesTotal: 894.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.0,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B22',
    unitFullId: 'Country_Corner/B22/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '62550064869972480',
    fullFrontendId: 'Country_Corner/B23/Rack_01',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 86.08570191782815,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B23',
    unitFullId: 'Country_Corner/B23/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '29724370716367113',
    fullFrontendId: 'Country_Corner/B23/Rack_02',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 84.83112479004856,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B23',
    unitFullId: 'Country_Corner/B23/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '1610670103853015',
    fullFrontendId: 'Country_Corner/B23/Rack_03',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.59718240493845,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B23',
    unitFullId: 'Country_Corner/B23/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '69369577755331986',
    fullFrontendId: 'Country_Corner/B23/Rack_04',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 84.9074895864692,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B23',
    unitFullId: 'Country_Corner/B23/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '57639174054994672',
    fullFrontendId: 'Country_Corner/B23/Rack_05',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.24972478808927,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B23',
    unitFullId: 'Country_Corner/B23/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '67365459092375554',
    fullFrontendId: 'Country_Corner/B23/Rack_06',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.7179895269163,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B23',
    unitFullId: 'Country_Corner/B23/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '32689711467471291',
    fullFrontendId: 'Country_Corner/B23/Rack_07',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.41058835355473,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B23',
    unitFullId: 'Country_Corner/B23/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '6978883631691550',
    fullFrontendId: 'Country_Corner/B23/Rack_08',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.0679809144473,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B23',
    unitFullId: 'Country_Corner/B23/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '38305957045744950',
    fullFrontendId: 'Country_Corner/B23/Rack_09',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.1767132350481,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B23',
    unitFullId: 'Country_Corner/B23/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '68114984296474538',
    fullFrontendId: 'Country_Corner/B23/Rack_10',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.5951836725065,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B23',
    unitFullId: 'Country_Corner/B23/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '17201046990530016',
    fullFrontendId: 'Country_Corner/B24/Rack_01',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.17219435831095,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B24',
    unitFullId: 'Country_Corner/B24/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '61434457278327309',
    fullFrontendId: 'Country_Corner/B24/Rack_02',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.45624192470069,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B24',
    unitFullId: 'Country_Corner/B24/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '27400757141998347',
    fullFrontendId: 'Country_Corner/B24/Rack_03',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.40497589979724,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B24',
    unitFullId: 'Country_Corner/B24/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '20110464637511486',
    fullFrontendId: 'Country_Corner/B24/Rack_04',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.19582424354435,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B24',
    unitFullId: 'Country_Corner/B24/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '45041541419960412',
    fullFrontendId: 'Country_Corner/B24/Rack_05',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 86.0344875746237,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B24',
    unitFullId: 'Country_Corner/B24/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '66839987110890160',
    fullFrontendId: 'Country_Corner/B24/Rack_06',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.58148005452149,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B24',
    unitFullId: 'Country_Corner/B24/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '34546484587110454',
    fullFrontendId: 'Country_Corner/B24/Rack_07',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 84.7837615718288,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B24',
    unitFullId: 'Country_Corner/B24/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '52855507319075531',
    fullFrontendId: 'Country_Corner/B24/Rack_08',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.44724064225692,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B24',
    unitFullId: 'Country_Corner/B24/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '31085199199260777',
    fullFrontendId: 'Country_Corner/B24/Rack_09',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.19276840839558,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B24',
    unitFullId: 'Country_Corner/B24/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '50712416082944508',
    fullFrontendId: 'Country_Corner/B24/Rack_10',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.64703434826497,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B24',
    unitFullId: 'Country_Corner/B24/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '24504887961452069',
    fullFrontendId: 'Country_Corner/B25/Rack_01',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.15354812629629,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B25',
    unitFullId: 'Country_Corner/B25/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '28117427348915420',
    fullFrontendId: 'Country_Corner/B25/Rack_02',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.35688341538602,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B25',
    unitFullId: 'Country_Corner/B25/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '6958246851868558',
    fullFrontendId: 'Country_Corner/B25/Rack_03',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.54280053152023,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B25',
    unitFullId: 'Country_Corner/B25/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '2954543959903114',
    fullFrontendId: 'Country_Corner/B25/Rack_04',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.65103090607712,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B25',
    unitFullId: 'Country_Corner/B25/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '6540304199980755',
    fullFrontendId: 'Country_Corner/B25/Rack_05',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.03121542570936,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B25',
    unitFullId: 'Country_Corner/B25/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '47665735283617424',
    fullFrontendId: 'Country_Corner/B25/Rack_06',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.29095397707381,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B25',
    unitFullId: 'Country_Corner/B25/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '69095184924677916',
    fullFrontendId: 'Country_Corner/B25/Rack_07',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.2488207544778,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B25',
    unitFullId: 'Country_Corner/B25/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '24121244713338821',
    fullFrontendId: 'Country_Corner/B25/Rack_08',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.19530557805398,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B25',
    unitFullId: 'Country_Corner/B25/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '6429553694724504',
    fullFrontendId: 'Country_Corner/B25/Rack_09',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.92094061991043,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B25',
    unitFullId: 'Country_Corner/B25/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '2435862662525847',
    fullFrontendId: 'Country_Corner/B25/Rack_10',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.51279886111438,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B25',
    unitFullId: 'Country_Corner/B25/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '14581783459110500',
    fullFrontendId: 'Country_Corner/B26/Rack_01',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 86.0,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B26',
    unitFullId: 'Country_Corner/B26/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '59395084066388735',
    fullFrontendId: 'Country_Corner/B26/Rack_02',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.66666293194253,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B26',
    unitFullId: 'Country_Corner/B26/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '17852576880260495',
    fullFrontendId: 'Country_Corner/B26/Rack_03',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 86.02795120692988,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B26',
    unitFullId: 'Country_Corner/B26/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '32790652432554140',
    fullFrontendId: 'Country_Corner/B26/Rack_04',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.70104392599144,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B26',
    unitFullId: 'Country_Corner/B26/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '61659681451544347',
    fullFrontendId: 'Country_Corner/B26/Rack_05',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 84.93549335803989,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B26',
    unitFullId: 'Country_Corner/B26/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '40969798542131576',
    fullFrontendId: 'Country_Corner/B26/Rack_06',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.24603412596622,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B26',
    unitFullId: 'Country_Corner/B26/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '22596396457745528',
    fullFrontendId: 'Country_Corner/B26/Rack_07',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.77137769258208,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B26',
    unitFullId: 'Country_Corner/B26/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '56079652480746013',
    fullFrontendId: 'Country_Corner/B26/Rack_08',
    ageInYears: 2.73972602739726,
    throughputTotal: 362800000.0,
    cyclesTotal: 907.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.17900350814045,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B26',
    unitFullId: 'Country_Corner/B26/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '10010385498247626',
    fullFrontendId: 'Country_Corner/B26/Rack_09',
    ageInYears: 2.73972602739726,
    throughputTotal: 357600000.0,
    cyclesTotal: 894.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.0,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B26',
    unitFullId: 'Country_Corner/B26/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '30388637531089197',
    fullFrontendId: 'Country_Corner/B26/Rack_10',
    ageInYears: 2.73972602739726,
    throughputTotal: 357600000.0,
    cyclesTotal: 894.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.6236945638549,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B26',
    unitFullId: 'Country_Corner/B26/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '67656174610726294',
    fullFrontendId: 'Country_Corner/B27/Rack_01',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.11322520635267,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B27',
    unitFullId: 'Country_Corner/B27/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '4061514289691207',
    fullFrontendId: 'Country_Corner/B27/Rack_02',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.37344674100756,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B27',
    unitFullId: 'Country_Corner/B27/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '36354892003688144',
    fullFrontendId: 'Country_Corner/B27/Rack_03',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 84.41892414580538,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B27',
    unitFullId: 'Country_Corner/B27/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '32471773617279006',
    fullFrontendId: 'Country_Corner/B27/Rack_04',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.0839880554258,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B27',
    unitFullId: 'Country_Corner/B27/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '28545074712574921',
    fullFrontendId: 'Country_Corner/B27/Rack_05',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.31553390240815,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B27',
    unitFullId: 'Country_Corner/B27/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '53237918646524405',
    fullFrontendId: 'Country_Corner/B27/Rack_06',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.01696939323664,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B27',
    unitFullId: 'Country_Corner/B27/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '48661999858345633',
    fullFrontendId: 'Country_Corner/B27/Rack_07',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.88102773900559,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B27',
    unitFullId: 'Country_Corner/B27/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '35017299569429283',
    fullFrontendId: 'Country_Corner/B27/Rack_08',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 84.9622619344379,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B27',
    unitFullId: 'Country_Corner/B27/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '70410253746328374',
    fullFrontendId: 'Country_Corner/B27/Rack_09',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.259291001817,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B27',
    unitFullId: 'Country_Corner/B27/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '46976829218980256',
    fullFrontendId: 'Country_Corner/B27/Rack_10',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.43052652101193,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B27',
    unitFullId: 'Country_Corner/B27/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '15990764837004244',
    fullFrontendId: 'Country_Corner/B28/Rack_01',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.82368633454593,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B28',
    unitFullId: 'Country_Corner/B28/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '43457394153082489',
    fullFrontendId: 'Country_Corner/B28/Rack_02',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 84.96054570247226,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B28',
    unitFullId: 'Country_Corner/B28/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '13471351640558659',
    fullFrontendId: 'Country_Corner/B28/Rack_03',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.74025347347258,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B28',
    unitFullId: 'Country_Corner/B28/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '43257018117311641',
    fullFrontendId: 'Country_Corner/B28/Rack_04',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.39437426613198,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B28',
    unitFullId: 'Country_Corner/B28/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '44441210032859093',
    fullFrontendId: 'Country_Corner/B28/Rack_05',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.09685175251171,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B28',
    unitFullId: 'Country_Corner/B28/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '56809198314856746',
    fullFrontendId: 'Country_Corner/B28/Rack_06',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.52993539010508,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B28',
    unitFullId: 'Country_Corner/B28/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '52892527099087293',
    fullFrontendId: 'Country_Corner/B28/Rack_07',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.45102225649813,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B28',
    unitFullId: 'Country_Corner/B28/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '1517276912271249',
    fullFrontendId: 'Country_Corner/B28/Rack_08',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.21123928467846,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B28',
    unitFullId: 'Country_Corner/B28/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '642901347155358',
    fullFrontendId: 'Country_Corner/B28/Rack_09',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.4122449733231,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B28',
    unitFullId: 'Country_Corner/B28/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '16728424670061118',
    fullFrontendId: 'Country_Corner/B28/Rack_10',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.27571026876757,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B28',
    unitFullId: 'Country_Corner/B28/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '46434595840970237',
    fullFrontendId: 'Country_Corner/B29/Rack_01',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.42535955140147,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B29',
    unitFullId: 'Country_Corner/B29/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '38611058194173256',
    fullFrontendId: 'Country_Corner/B29/Rack_02',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.58994355018241,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B29',
    unitFullId: 'Country_Corner/B29/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '70046936809406829',
    fullFrontendId: 'Country_Corner/B29/Rack_03',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.8671093926697,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B29',
    unitFullId: 'Country_Corner/B29/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '18076209839280849',
    fullFrontendId: 'Country_Corner/B29/Rack_04',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.0,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B29',
    unitFullId: 'Country_Corner/B29/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '54733539380796709',
    fullFrontendId: 'Country_Corner/B29/Rack_05',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 86.03121436022298,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B29',
    unitFullId: 'Country_Corner/B29/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '37167083848744828',
    fullFrontendId: 'Country_Corner/B29/Rack_06',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 84.80567800796935,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B29',
    unitFullId: 'Country_Corner/B29/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '35197177310155977',
    fullFrontendId: 'Country_Corner/B29/Rack_07',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.34576881931542,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B29',
    unitFullId: 'Country_Corner/B29/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '69588550128907886',
    fullFrontendId: 'Country_Corner/B29/Rack_08',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.56779950977146,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B29',
    unitFullId: 'Country_Corner/B29/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '54987447907194742',
    fullFrontendId: 'Country_Corner/B29/Rack_09',
    ageInYears: 2.73972602739726,
    throughputTotal: 356000000.0,
    cyclesTotal: 890.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.4756019081466,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B29',
    unitFullId: 'Country_Corner/B29/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '22959367894914781',
    fullFrontendId: 'Country_Corner/B29/Rack_10',
    ageInYears: 2.73972602739726,
    throughputTotal: 356800000.0,
    cyclesTotal: 892.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.0,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B29',
    unitFullId: 'Country_Corner/B29/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '54426466015475921',
    fullFrontendId: 'Country_Corner/B30/Rack_01',
    ageInYears: 2.73972602739726,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.32886767271891,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B30',
    unitFullId: 'Country_Corner/B30/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '769405584894263',
    fullFrontendId: 'Country_Corner/B30/Rack_02',
    ageInYears: 2.73972602739726,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.24340406742844,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B30',
    unitFullId: 'Country_Corner/B30/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '44604054646835931',
    fullFrontendId: 'Country_Corner/B30/Rack_03',
    ageInYears: 2.73972602739726,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.21449492074282,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B30',
    unitFullId: 'Country_Corner/B30/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '12242169608091269',
    fullFrontendId: 'Country_Corner/B30/Rack_04',
    ageInYears: 2.73972602739726,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.6461849769324,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B30',
    unitFullId: 'Country_Corner/B30/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '60137551809065668',
    fullFrontendId: 'Country_Corner/B30/Rack_05',
    ageInYears: 2.73972602739726,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.49840899361561,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B30',
    unitFullId: 'Country_Corner/B30/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '49907290519630689',
    fullFrontendId: 'Country_Corner/B30/Rack_06',
    ageInYears: 2.73972602739726,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.18343146924789,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B30',
    unitFullId: 'Country_Corner/B30/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '39521135278296569',
    fullFrontendId: 'Country_Corner/B30/Rack_07',
    ageInYears: 2.73972602739726,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.66118431045606,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B30',
    unitFullId: 'Country_Corner/B30/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '45762990185226657',
    fullFrontendId: 'Country_Corner/B30/Rack_08',
    ageInYears: 2.73972602739726,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.48349420408907,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B30',
    unitFullId: 'Country_Corner/B30/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '40376310974477272',
    fullFrontendId: 'Country_Corner/B30/Rack_09',
    ageInYears: 2.73972602739726,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.63516298347778,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B30',
    unitFullId: 'Country_Corner/B30/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '11931954233655033',
    fullFrontendId: 'Country_Corner/B30/Rack_10',
    ageInYears: 2.73972602739726,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.58019300040317,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B30',
    unitFullId: 'Country_Corner/B30/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '3516879690624759',
    fullFrontendId: 'Country_Corner/B31/Rack_01',
    ageInYears: 2.73972602739726,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.14260584454946,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B31',
    unitFullId: 'Country_Corner/B31/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '36314423494654061',
    fullFrontendId: 'Country_Corner/B31/Rack_02',
    ageInYears: 2.73972602739726,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.22325003576701,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B31',
    unitFullId: 'Country_Corner/B31/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '23741111991284011',
    fullFrontendId: 'Country_Corner/B31/Rack_03',
    ageInYears: 2.73972602739726,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.61549242936307,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B31',
    unitFullId: 'Country_Corner/B31/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '36562173920921604',
    fullFrontendId: 'Country_Corner/B31/Rack_04',
    ageInYears: 2.73972602739726,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.57441542745613,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B31',
    unitFullId: 'Country_Corner/B31/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '20595154266960448',
    fullFrontendId: 'Country_Corner/B31/Rack_05',
    ageInYears: 2.73972602739726,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.38503386963684,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B31',
    unitFullId: 'Country_Corner/B31/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '42577330539636526',
    fullFrontendId: 'Country_Corner/B31/Rack_06',
    ageInYears: 2.73972602739726,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.42650256281873,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B31',
    unitFullId: 'Country_Corner/B31/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '13713968915224737',
    fullFrontendId: 'Country_Corner/B31/Rack_07',
    ageInYears: 2.73972602739726,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.77460381656262,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B31',
    unitFullId: 'Country_Corner/B31/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '27927971759830067',
    fullFrontendId: 'Country_Corner/B31/Rack_08',
    ageInYears: 2.73972602739726,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.21383293117535,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B31',
    unitFullId: 'Country_Corner/B31/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '52491862310218294',
    fullFrontendId: 'Country_Corner/B31/Rack_09',
    ageInYears: 2.73972602739726,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.5554335621771,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B31',
    unitFullId: 'Country_Corner/B31/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '35059889886841900',
    fullFrontendId: 'Country_Corner/B31/Rack_10',
    ageInYears: 2.73972602739726,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 85.33064655209593,
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B31',
    unitFullId: 'Country_Corner/B31/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 2,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 0,
  },
  {
    id: '44262786570105247',
    fullFrontendId: 'Smart_Hill/B01/Rack_01',
    ageInYears: 5.205479452054795,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.19395489829108,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B01',
    unitFullId: 'Smart_Hill/B01/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '26905524237387724',
    fullFrontendId: 'Smart_Hill/B01/Rack_02',
    ageInYears: 5.205479452054795,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.58889231485541,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B01',
    unitFullId: 'Smart_Hill/B01/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '43266919750272151',
    fullFrontendId: 'Smart_Hill/B01/Rack_03',
    ageInYears: 5.205479452054795,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.50688416395566,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B01',
    unitFullId: 'Smart_Hill/B01/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '59086561782369494',
    fullFrontendId: 'Smart_Hill/B01/Rack_04',
    ageInYears: 5.205479452054795,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.50331215005944,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B01',
    unitFullId: 'Smart_Hill/B01/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '4655539236530224',
    fullFrontendId: 'Smart_Hill/B01/Rack_05',
    ageInYears: 5.205479452054795,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.65090290140554,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B01',
    unitFullId: 'Smart_Hill/B01/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '66684427417835148',
    fullFrontendId: 'Smart_Hill/B01/Rack_06',
    ageInYears: 5.205479452054795,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 1.0,
    sohAccure: 86.0,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B01',
    unitFullId: 'Smart_Hill/B01/Rack_06',
    dataStatus: 1,
    complianceStatus: 1,
    warrantyCoverage: 2,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 1,
  },
  {
    id: '44378986949131962',
    fullFrontendId: 'Smart_Hill/B01/Rack_07',
    ageInYears: 5.205479452054795,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.46384515064774,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B01',
    unitFullId: 'Smart_Hill/B01/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '6235619112861210',
    fullFrontendId: 'Smart_Hill/B02/Rack_01',
    ageInYears: 5.205479452054795,
    throughputTotal: 680800000.0,
    cyclesTotal: 1702.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.16617923228121,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B02',
    unitFullId: 'Smart_Hill/B02/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '32005371243043353',
    fullFrontendId: 'Smart_Hill/B02/Rack_02',
    ageInYears: 5.205479452054795,
    throughputTotal: 680800000.0,
    cyclesTotal: 1702.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.35650916500579,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B02',
    unitFullId: 'Smart_Hill/B02/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '65123223871815290',
    fullFrontendId: 'Smart_Hill/B02/Rack_03',
    ageInYears: 5.205479452054795,
    throughputTotal: 680800000.0,
    cyclesTotal: 1702.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.22021634294894,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B02',
    unitFullId: 'Smart_Hill/B02/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '18568289531407894',
    fullFrontendId: 'Smart_Hill/B02/Rack_04',
    ageInYears: 5.205479452054795,
    throughputTotal: 680800000.0,
    cyclesTotal: 1702.0,
    sohPenaltyMax: 0.0,
    sohAccure: 90.0,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B02',
    unitFullId: 'Smart_Hill/B02/Rack_04',
    dataStatus: 1,
    complianceStatus: 1,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 1,
  },
  {
    id: '7094469504664286',
    fullFrontendId: 'Smart_Hill/B02/Rack_05',
    ageInYears: 5.205479452054795,
    throughputTotal: 680800000.0,
    cyclesTotal: 1702.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.43780636689033,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B02',
    unitFullId: 'Smart_Hill/B02/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '36078247376804333',
    fullFrontendId: 'Smart_Hill/B02/Rack_06',
    ageInYears: 5.205479452054795,
    throughputTotal: 680800000.0,
    cyclesTotal: 1702.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.01379305428921,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B02',
    unitFullId: 'Smart_Hill/B02/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '36209438535110631',
    fullFrontendId: 'Smart_Hill/B02/Rack_07',
    ageInYears: 5.205479452054795,
    throughputTotal: 680800000.0,
    cyclesTotal: 1702.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.88697544196489,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B02',
    unitFullId: 'Smart_Hill/B02/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '35318091892249771',
    fullFrontendId: 'Smart_Hill/B03/Rack_01',
    ageInYears: 5.205479452054795,
    throughputTotal: 685600000.0,
    cyclesTotal: 1714.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.0,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B03',
    unitFullId: 'Smart_Hill/B03/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '14107409534745415',
    fullFrontendId: 'Smart_Hill/B03/Rack_02',
    ageInYears: 5.205479452054795,
    throughputTotal: 683200000.0,
    cyclesTotal: 1708.0,
    sohPenaltyMax: 0.0,
    sohAccure: 90.0,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B03',
    unitFullId: 'Smart_Hill/B03/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '49734039780099825',
    fullFrontendId: 'Smart_Hill/B03/Rack_03',
    ageInYears: 5.205479452054795,
    throughputTotal: 683200000.0,
    cyclesTotal: 1708.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.60669252130927,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B03',
    unitFullId: 'Smart_Hill/B03/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '41650961282610639',
    fullFrontendId: 'Smart_Hill/B03/Rack_04',
    ageInYears: 5.205479452054795,
    throughputTotal: 683200000.0,
    cyclesTotal: 1708.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.49675806744813,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B03',
    unitFullId: 'Smart_Hill/B03/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '62762969003009503',
    fullFrontendId: 'Smart_Hill/B03/Rack_05',
    ageInYears: 5.205479452054795,
    throughputTotal: 683200000.0,
    cyclesTotal: 1708.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.4464952043749,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B03',
    unitFullId: 'Smart_Hill/B03/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '41265578664303445',
    fullFrontendId: 'Smart_Hill/B03/Rack_06',
    ageInYears: 5.205479452054795,
    throughputTotal: 683200000.0,
    cyclesTotal: 1708.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.44776291203854,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B03',
    unitFullId: 'Smart_Hill/B03/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '52000826579640257',
    fullFrontendId: 'Smart_Hill/B03/Rack_07',
    ageInYears: 5.205479452054795,
    throughputTotal: 683200000.0,
    cyclesTotal: 1708.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.25558522740518,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B03',
    unitFullId: 'Smart_Hill/B03/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '38659240387588959',
    fullFrontendId: 'Smart_Hill/B04/Rack_01',
    ageInYears: 5.205479452054795,
    throughputTotal: 680400000.0,
    cyclesTotal: 1701.0,
    sohPenaltyMax: 0.0,
    sohAccure: 88.9900829478135,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B04',
    unitFullId: 'Smart_Hill/B04/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '31333048061248156',
    fullFrontendId: 'Smart_Hill/B04/Rack_02',
    ageInYears: 5.205479452054795,
    throughputTotal: 680400000.0,
    cyclesTotal: 1701.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.28200062671738,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B04',
    unitFullId: 'Smart_Hill/B04/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '49447700021204043',
    fullFrontendId: 'Smart_Hill/B04/Rack_03',
    ageInYears: 5.205479452054795,
    throughputTotal: 680400000.0,
    cyclesTotal: 1701.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.05611074580563,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B04',
    unitFullId: 'Smart_Hill/B04/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '17141526905007658',
    fullFrontendId: 'Smart_Hill/B04/Rack_04',
    ageInYears: 5.205479452054795,
    throughputTotal: 680400000.0,
    cyclesTotal: 1701.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.55179517928458,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B04',
    unitFullId: 'Smart_Hill/B04/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '32434374897784146',
    fullFrontendId: 'Smart_Hill/B04/Rack_05',
    ageInYears: 5.205479452054795,
    throughputTotal: 680400000.0,
    cyclesTotal: 1701.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.21514204480862,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B04',
    unitFullId: 'Smart_Hill/B04/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '24277162998605119',
    fullFrontendId: 'Smart_Hill/B04/Rack_06',
    ageInYears: 5.205479452054795,
    throughputTotal: 680400000.0,
    cyclesTotal: 1701.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.0116101002215,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B04',
    unitFullId: 'Smart_Hill/B04/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '47209317785957315',
    fullFrontendId: 'Smart_Hill/B04/Rack_07',
    ageInYears: 5.205479452054795,
    throughputTotal: 680400000.0,
    cyclesTotal: 1701.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.16284350676335,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B04',
    unitFullId: 'Smart_Hill/B04/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '61939568820839264',
    fullFrontendId: 'Smart_Hill/B05/Rack_01',
    ageInYears: 5.205479452054795,
    throughputTotal: 680400000.0,
    cyclesTotal: 1701.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.38313869554194,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B05',
    unitFullId: 'Smart_Hill/B05/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '47907067275323195',
    fullFrontendId: 'Smart_Hill/B05/Rack_02',
    ageInYears: 5.205479452054795,
    throughputTotal: 680400000.0,
    cyclesTotal: 1701.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.09014189341806,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B05',
    unitFullId: 'Smart_Hill/B05/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '48526863698603864',
    fullFrontendId: 'Smart_Hill/B05/Rack_03',
    ageInYears: 5.205479452054795,
    throughputTotal: 625968000.0,
    cyclesTotal: 1564.92,
    sohPenaltyMax: 0.0,
    sohAccure: 89.01259314058932,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B05',
    unitFullId: 'Smart_Hill/B05/Rack_03',
    dataStatus: 1,
    complianceStatus: 2,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 1,
  },
  {
    id: '25250069974272448',
    fullFrontendId: 'Smart_Hill/B05/Rack_04',
    ageInYears: 5.205479452054795,
    throughputTotal: 680400000.0,
    cyclesTotal: 1701.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.33236542270683,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B05',
    unitFullId: 'Smart_Hill/B05/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '5856479230073424',
    fullFrontendId: 'Smart_Hill/B05/Rack_05',
    ageInYears: 5.205479452054795,
    throughputTotal: 680400000.0,
    cyclesTotal: 1701.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.0,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B05',
    unitFullId: 'Smart_Hill/B05/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '20471540913518535',
    fullFrontendId: 'Smart_Hill/B05/Rack_06',
    ageInYears: 5.205479452054795,
    throughputTotal: 683600000.0,
    cyclesTotal: 1709.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.0,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B05',
    unitFullId: 'Smart_Hill/B05/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '50603710744382028',
    fullFrontendId: 'Smart_Hill/B05/Rack_07',
    ageInYears: 5.205479452054795,
    throughputTotal: 683600000.0,
    cyclesTotal: 1709.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.11794776757375,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B05',
    unitFullId: 'Smart_Hill/B05/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '21633242953326513',
    fullFrontendId: 'Smart_Hill/B06/Rack_01',
    ageInYears: 5.205479452054795,
    throughputTotal: 685600000.0,
    cyclesTotal: 1714.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.32887424046655,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B06',
    unitFullId: 'Smart_Hill/B06/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '63716930169321346',
    fullFrontendId: 'Smart_Hill/B06/Rack_02',
    ageInYears: 5.205479452054795,
    throughputTotal: 685600000.0,
    cyclesTotal: 1714.0,
    sohPenaltyMax: 0.0,
    sohAccure: 88.82483395681005,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B06',
    unitFullId: 'Smart_Hill/B06/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '4337717586297350',
    fullFrontendId: 'Smart_Hill/B06/Rack_03',
    ageInYears: 5.205479452054795,
    throughputTotal: 685600000.0,
    cyclesTotal: 1714.0,
    sohPenaltyMax: 0.0,
    sohAccure: 90.0,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B06',
    unitFullId: 'Smart_Hill/B06/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '1816065337026227',
    fullFrontendId: 'Smart_Hill/B06/Rack_04',
    ageInYears: 5.205479452054795,
    throughputTotal: 680800000.0,
    cyclesTotal: 1702.0,
    sohPenaltyMax: 0.0,
    sohAccure: 90.0,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B06',
    unitFullId: 'Smart_Hill/B06/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '23078986167548976',
    fullFrontendId: 'Smart_Hill/B06/Rack_05',
    ageInYears: 5.205479452054795,
    throughputTotal: 680800000.0,
    cyclesTotal: 1702.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.19522511374569,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B06',
    unitFullId: 'Smart_Hill/B06/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '37061098950414129',
    fullFrontendId: 'Smart_Hill/B06/Rack_06',
    ageInYears: 5.205479452054795,
    throughputTotal: 680800000.0,
    cyclesTotal: 1702.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.35253152893866,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B06',
    unitFullId: 'Smart_Hill/B06/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '46039135135769811',
    fullFrontendId: 'Smart_Hill/B06/Rack_07',
    ageInYears: 5.205479452054795,
    throughputTotal: 680800000.0,
    cyclesTotal: 1702.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.70186612434412,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B06',
    unitFullId: 'Smart_Hill/B06/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '56395827885335761',
    fullFrontendId: 'Smart_Hill/B07/Rack_01',
    ageInYears: 5.205479452054795,
    throughputTotal: 683600000.0,
    cyclesTotal: 1709.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.51655714621985,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B07',
    unitFullId: 'Smart_Hill/B07/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '68288132438534195',
    fullFrontendId: 'Smart_Hill/B07/Rack_02',
    ageInYears: 5.205479452054795,
    throughputTotal: 683600000.0,
    cyclesTotal: 1709.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.21127770027023,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B07',
    unitFullId: 'Smart_Hill/B07/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '42520939806310753',
    fullFrontendId: 'Smart_Hill/B07/Rack_03',
    ageInYears: 5.205479452054795,
    throughputTotal: 683600000.0,
    cyclesTotal: 1709.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.25355439688845,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B07',
    unitFullId: 'Smart_Hill/B07/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '14659260481768716',
    fullFrontendId: 'Smart_Hill/B07/Rack_04',
    ageInYears: 5.205479452054795,
    throughputTotal: 683600000.0,
    cyclesTotal: 1709.0,
    sohPenaltyMax: 0.0,
    sohAccure: 88.95850044986791,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B07',
    unitFullId: 'Smart_Hill/B07/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '9308028791642601',
    fullFrontendId: 'Smart_Hill/B07/Rack_05',
    ageInYears: 5.205479452054795,
    throughputTotal: 683600000.0,
    cyclesTotal: 1709.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.25370531846154,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B07',
    unitFullId: 'Smart_Hill/B07/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '42580670235822364',
    fullFrontendId: 'Smart_Hill/B07/Rack_06',
    ageInYears: 5.205479452054795,
    throughputTotal: 683600000.0,
    cyclesTotal: 1709.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.17266166758321,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B07',
    unitFullId: 'Smart_Hill/B07/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '7037076435548809',
    fullFrontendId: 'Smart_Hill/B07/Rack_07',
    ageInYears: 5.205479452054795,
    throughputTotal: 683600000.0,
    cyclesTotal: 1709.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.35607482736069,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B07',
    unitFullId: 'Smart_Hill/B07/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '2538918863590415',
    fullFrontendId: 'Smart_Hill/B08/Rack_01',
    ageInYears: 5.205479452054795,
    throughputTotal: 683600000.0,
    cyclesTotal: 1709.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.01108997619356,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B08',
    unitFullId: 'Smart_Hill/B08/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '36828021029146421',
    fullFrontendId: 'Smart_Hill/B08/Rack_02',
    ageInYears: 5.205479452054795,
    throughputTotal: 683600000.0,
    cyclesTotal: 1709.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.41506321353161,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B08',
    unitFullId: 'Smart_Hill/B08/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '51461022411741932',
    fullFrontendId: 'Smart_Hill/B08/Rack_03',
    ageInYears: 5.205479452054795,
    throughputTotal: 683600000.0,
    cyclesTotal: 1709.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.71908093316003,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B08',
    unitFullId: 'Smart_Hill/B08/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '62334855922460872',
    fullFrontendId: 'Smart_Hill/B08/Rack_04',
    ageInYears: 5.205479452054795,
    throughputTotal: 683600000.0,
    cyclesTotal: 1709.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.22663121472219,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B08',
    unitFullId: 'Smart_Hill/B08/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '25139187188403141',
    fullFrontendId: 'Smart_Hill/B08/Rack_05',
    ageInYears: 5.205479452054795,
    throughputTotal: 683600000.0,
    cyclesTotal: 1709.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.37977277588894,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B08',
    unitFullId: 'Smart_Hill/B08/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '59702983162494328',
    fullFrontendId: 'Smart_Hill/B08/Rack_06',
    ageInYears: 5.205479452054795,
    throughputTotal: 683600000.0,
    cyclesTotal: 1709.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.46630245677258,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B08',
    unitFullId: 'Smart_Hill/B08/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '25492131571971810',
    fullFrontendId: 'Smart_Hill/B08/Rack_07',
    ageInYears: 5.205479452054795,
    throughputTotal: 683600000.0,
    cyclesTotal: 1709.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.1388931176935,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B08',
    unitFullId: 'Smart_Hill/B08/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '7768783131568285',
    fullFrontendId: 'Smart_Hill/B09/Rack_01',
    ageInYears: 5.205479452054795,
    throughputTotal: 683600000.0,
    cyclesTotal: 1709.0,
    sohPenaltyMax: 0.0,
    sohAccure: 90.0,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B09',
    unitFullId: 'Smart_Hill/B09/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '25163592552586681',
    fullFrontendId: 'Smart_Hill/B09/Rack_02',
    ageInYears: 5.205479452054795,
    throughputTotal: 684400000.0,
    cyclesTotal: 1711.0,
    sohPenaltyMax: 0.0,
    sohAccure: 90.0,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B09',
    unitFullId: 'Smart_Hill/B09/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '26613609825343367',
    fullFrontendId: 'Smart_Hill/B09/Rack_03',
    ageInYears: 5.205479452054795,
    throughputTotal: 684400000.0,
    cyclesTotal: 1711.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.28856208882391,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B09',
    unitFullId: 'Smart_Hill/B09/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '28253986343896803',
    fullFrontendId: 'Smart_Hill/B09/Rack_04',
    ageInYears: 5.205479452054795,
    throughputTotal: 684400000.0,
    cyclesTotal: 1711.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.02735632410261,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B09',
    unitFullId: 'Smart_Hill/B09/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '31090759195636136',
    fullFrontendId: 'Smart_Hill/B09/Rack_05',
    ageInYears: 5.205479452054795,
    throughputTotal: 684400000.0,
    cyclesTotal: 1711.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.26661231153693,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B09',
    unitFullId: 'Smart_Hill/B09/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '67340213169365601',
    fullFrontendId: 'Smart_Hill/B09/Rack_06',
    ageInYears: 5.205479452054795,
    throughputTotal: 684400000.0,
    cyclesTotal: 1711.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.40865874663288,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B09',
    unitFullId: 'Smart_Hill/B09/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '11158484892686668',
    fullFrontendId: 'Smart_Hill/B10/Rack_01',
    ageInYears: 5.205479452054795,
    throughputTotal: 680400000.0,
    cyclesTotal: 1701.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.69460234159777,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B10',
    unitFullId: 'Smart_Hill/B10/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '68927473038752950',
    fullFrontendId: 'Smart_Hill/B10/Rack_02',
    ageInYears: 5.205479452054795,
    throughputTotal: 680400000.0,
    cyclesTotal: 1701.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.54704050708482,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B10',
    unitFullId: 'Smart_Hill/B10/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '50436436145897532',
    fullFrontendId: 'Smart_Hill/B10/Rack_03',
    ageInYears: 5.205479452054795,
    throughputTotal: 680400000.0,
    cyclesTotal: 1701.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.90521399651271,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B10',
    unitFullId: 'Smart_Hill/B10/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '39820713219009219',
    fullFrontendId: 'Smart_Hill/B10/Rack_04',
    ageInYears: 5.205479452054795,
    throughputTotal: 680400000.0,
    cyclesTotal: 1701.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.02905499039284,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B10',
    unitFullId: 'Smart_Hill/B10/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '49339515477753697',
    fullFrontendId: 'Smart_Hill/B10/Rack_05',
    ageInYears: 5.205479452054795,
    throughputTotal: 680400000.0,
    cyclesTotal: 1701.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.52095545027545,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B10',
    unitFullId: 'Smart_Hill/B10/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '28724523743614418',
    fullFrontendId: 'Smart_Hill/B10/Rack_06',
    ageInYears: 5.205479452054795,
    throughputTotal: 680400000.0,
    cyclesTotal: 1701.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.31426186098076,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B10',
    unitFullId: 'Smart_Hill/B10/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '13376914750853058',
    fullFrontendId: 'Smart_Hill/B11/Rack_01',
    ageInYears: 5.205479452054795,
    throughputTotal: 680400000.0,
    cyclesTotal: 1701.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.91620013922456,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B11',
    unitFullId: 'Smart_Hill/B11/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '56841109492578227',
    fullFrontendId: 'Smart_Hill/B11/Rack_02',
    ageInYears: 5.205479452054795,
    throughputTotal: 680400000.0,
    cyclesTotal: 1701.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.01676977365271,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B11',
    unitFullId: 'Smart_Hill/B11/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '10946992763985964',
    fullFrontendId: 'Smart_Hill/B11/Rack_03',
    ageInYears: 5.205479452054795,
    throughputTotal: 680400000.0,
    cyclesTotal: 1701.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.0,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B11',
    unitFullId: 'Smart_Hill/B11/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '35323450106053539',
    fullFrontendId: 'Smart_Hill/B11/Rack_04',
    ageInYears: 5.205479452054795,
    throughputTotal: 680400000.0,
    cyclesTotal: 1701.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.07944146562605,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B11',
    unitFullId: 'Smart_Hill/B11/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '3521236114852592',
    fullFrontendId: 'Smart_Hill/B11/Rack_05',
    ageInYears: 5.205479452054795,
    throughputTotal: 682000000.0,
    cyclesTotal: 1705.0,
    sohPenaltyMax: 0.0,
    sohAccure: 90.0,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B11',
    unitFullId: 'Smart_Hill/B11/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '13008081726865069',
    fullFrontendId: 'Smart_Hill/B11/Rack_06',
    ageInYears: 5.205479452054795,
    throughputTotal: 682000000.0,
    cyclesTotal: 1705.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.10153275275502,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B11',
    unitFullId: 'Smart_Hill/B11/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '49552413449274128',
    fullFrontendId: 'Smart_Hill/B12/Rack_01',
    ageInYears: 5.205479452054795,
    throughputTotal: 687600000.0,
    cyclesTotal: 1719.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.03151946079315,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B12',
    unitFullId: 'Smart_Hill/B12/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '30191853110409596',
    fullFrontendId: 'Smart_Hill/B12/Rack_02',
    ageInYears: 5.205479452054795,
    throughputTotal: 687600000.0,
    cyclesTotal: 1719.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.30437739520211,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B12',
    unitFullId: 'Smart_Hill/B12/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '28070762464680969',
    fullFrontendId: 'Smart_Hill/B12/Rack_03',
    ageInYears: 5.205479452054795,
    throughputTotal: 687600000.0,
    cyclesTotal: 1719.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.0,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B12',
    unitFullId: 'Smart_Hill/B12/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '69832781860857833',
    fullFrontendId: 'Smart_Hill/B12/Rack_04',
    ageInYears: 5.205479452054795,
    throughputTotal: 687600000.0,
    cyclesTotal: 1719.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.82211051102402,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B12',
    unitFullId: 'Smart_Hill/B12/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '22891281137356005',
    fullFrontendId: 'Smart_Hill/B12/Rack_05',
    ageInYears: 5.205479452054795,
    throughputTotal: 680800000.0,
    cyclesTotal: 1702.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.0,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B12',
    unitFullId: 'Smart_Hill/B12/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '32052106622291805',
    fullFrontendId: 'Smart_Hill/B12/Rack_06',
    ageInYears: 5.205479452054795,
    throughputTotal: 680800000.0,
    cyclesTotal: 1702.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.08618816256053,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B12',
    unitFullId: 'Smart_Hill/B12/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '38113168415355033',
    fullFrontendId: 'Smart_Hill/B13/Rack_01',
    ageInYears: 5.205479452054795,
    throughputTotal: 686000000.0,
    cyclesTotal: 1715.0,
    sohPenaltyMax: 0.0,
    sohAccure: 88.98973485785474,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B13',
    unitFullId: 'Smart_Hill/B13/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '14302806928450382',
    fullFrontendId: 'Smart_Hill/B13/Rack_02',
    ageInYears: 5.205479452054795,
    throughputTotal: 686000000.0,
    cyclesTotal: 1715.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.0,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B13',
    unitFullId: 'Smart_Hill/B13/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '62376281187427261',
    fullFrontendId: 'Smart_Hill/B13/Rack_03',
    ageInYears: 5.205479452054795,
    throughputTotal: 686000000.0,
    cyclesTotal: 1715.0,
    sohPenaltyMax: 0.0,
    sohAccure: 88.86318929715306,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B13',
    unitFullId: 'Smart_Hill/B13/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '17255494565430446',
    fullFrontendId: 'Smart_Hill/B13/Rack_04',
    ageInYears: 5.205479452054795,
    throughputTotal: 686000000.0,
    cyclesTotal: 1715.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.80869688901556,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B13',
    unitFullId: 'Smart_Hill/B13/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '7023040110786477',
    fullFrontendId: 'Smart_Hill/B13/Rack_05',
    ageInYears: 5.205479452054795,
    throughputTotal: 688000000.0,
    cyclesTotal: 1720.0,
    sohPenaltyMax: 0.0,
    sohAccure: 90.0,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B13',
    unitFullId: 'Smart_Hill/B13/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '26764239342805376',
    fullFrontendId: 'Smart_Hill/B13/Rack_06',
    ageInYears: 5.205479452054795,
    throughputTotal: 688000000.0,
    cyclesTotal: 1720.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.11850656362785,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B13',
    unitFullId: 'Smart_Hill/B13/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '30553784399725380',
    fullFrontendId: 'Smart_Hill/B13/Rack_07',
    ageInYears: 5.205479452054795,
    throughputTotal: 688000000.0,
    cyclesTotal: 1720.0,
    sohPenaltyMax: 0.0,
    sohAccure: 88.74531890053198,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B13',
    unitFullId: 'Smart_Hill/B13/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '47066440660800271',
    fullFrontendId: 'Smart_Hill/B14/Rack_01',
    ageInYears: 5.205479452054795,
    throughputTotal: 680800000.0,
    cyclesTotal: 1702.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.66542097150888,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B14',
    unitFullId: 'Smart_Hill/B14/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '13412229836202362',
    fullFrontendId: 'Smart_Hill/B14/Rack_02',
    ageInYears: 5.205479452054795,
    throughputTotal: 680800000.0,
    cyclesTotal: 1702.0,
    sohPenaltyMax: 0.0,
    sohAccure: 90.0,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B14',
    unitFullId: 'Smart_Hill/B14/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '3602344568108499',
    fullFrontendId: 'Smart_Hill/B14/Rack_03',
    ageInYears: 5.205479452054795,
    throughputTotal: 686800000.0,
    cyclesTotal: 1717.0,
    sohPenaltyMax: 0.0,
    sohAccure: 90.0,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B14',
    unitFullId: 'Smart_Hill/B14/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '44577104628557354',
    fullFrontendId: 'Smart_Hill/B14/Rack_04',
    ageInYears: 5.205479452054795,
    throughputTotal: 686800000.0,
    cyclesTotal: 1717.0,
    sohPenaltyMax: 0.0,
    sohAccure: 88.78093096162094,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B14',
    unitFullId: 'Smart_Hill/B14/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '30492556676042766',
    fullFrontendId: 'Smart_Hill/B14/Rack_05',
    ageInYears: 5.205479452054795,
    throughputTotal: 686800000.0,
    cyclesTotal: 1717.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.07944675237312,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B14',
    unitFullId: 'Smart_Hill/B14/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '70071017920417767',
    fullFrontendId: 'Smart_Hill/B14/Rack_06',
    ageInYears: 5.205479452054795,
    throughputTotal: 686800000.0,
    cyclesTotal: 1717.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.26083236917471,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B14',
    unitFullId: 'Smart_Hill/B14/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '33143413568738102',
    fullFrontendId: 'Smart_Hill/B14/Rack_07',
    ageInYears: 5.205479452054795,
    throughputTotal: 686800000.0,
    cyclesTotal: 1717.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.27335343738868,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B14',
    unitFullId: 'Smart_Hill/B14/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '21653856199572797',
    fullFrontendId: 'Smart_Hill/B15/Rack_01',
    ageInYears: 5.205479452054795,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.12423961781548,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B15',
    unitFullId: 'Smart_Hill/B15/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '27365264825782934',
    fullFrontendId: 'Smart_Hill/B15/Rack_02',
    ageInYears: 5.205479452054795,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.4461142389635,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B15',
    unitFullId: 'Smart_Hill/B15/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '63557573616345587',
    fullFrontendId: 'Smart_Hill/B15/Rack_03',
    ageInYears: 5.205479452054795,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 88.93897313044448,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B15',
    unitFullId: 'Smart_Hill/B15/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '23181206242594511',
    fullFrontendId: 'Smart_Hill/B15/Rack_04',
    ageInYears: 5.205479452054795,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.21654541375287,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B15',
    unitFullId: 'Smart_Hill/B15/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '62480409727017366',
    fullFrontendId: 'Smart_Hill/B15/Rack_05',
    ageInYears: 5.205479452054795,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.29534794877283,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B15',
    unitFullId: 'Smart_Hill/B15/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '14158364375943252',
    fullFrontendId: 'Smart_Hill/B15/Rack_06',
    ageInYears: 5.205479452054795,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.41359090947688,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B15',
    unitFullId: 'Smart_Hill/B15/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '11314509918393158',
    fullFrontendId: 'Smart_Hill/B15/Rack_07',
    ageInYears: 5.205479452054795,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.47274372268592,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B15',
    unitFullId: 'Smart_Hill/B15/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '17178712120278320',
    fullFrontendId: 'Smart_Hill/B16/Rack_01',
    ageInYears: 5.205479452054795,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.0,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B16',
    unitFullId: 'Smart_Hill/B16/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '26682097369265135',
    fullFrontendId: 'Smart_Hill/B16/Rack_02',
    ageInYears: 5.205479452054795,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 88.79902500803857,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B16',
    unitFullId: 'Smart_Hill/B16/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '23166424732939833',
    fullFrontendId: 'Smart_Hill/B16/Rack_03',
    ageInYears: 5.205479452054795,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.6425623058288,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B16',
    unitFullId: 'Smart_Hill/B16/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '52378953485546685',
    fullFrontendId: 'Smart_Hill/B16/Rack_04',
    ageInYears: 5.205479452054795,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.35895346285314,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B16',
    unitFullId: 'Smart_Hill/B16/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '17927613245815604',
    fullFrontendId: 'Smart_Hill/B16/Rack_05',
    ageInYears: 5.205479452054795,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.03471329829229,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B16',
    unitFullId: 'Smart_Hill/B16/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '65784297568105507',
    fullFrontendId: 'Smart_Hill/B16/Rack_06',
    ageInYears: 5.205479452054795,
    throughputTotal: 680000000.0,
    cyclesTotal: 1700.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.72460485191601,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B16',
    unitFullId: 'Smart_Hill/B16/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '8656234036716442',
    fullFrontendId: 'Smart_Hill/B16/Rack_07',
    ageInYears: 5.205479452054795,
    throughputTotal: 685200000.0,
    cyclesTotal: 1713.0,
    sohPenaltyMax: 0.0,
    sohAccure: 90.0,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B16',
    unitFullId: 'Smart_Hill/B16/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '10110088247115396',
    fullFrontendId: 'Smart_Hill/B17/Rack_01',
    ageInYears: 5.205479452054795,
    throughputTotal: 682400000.0,
    cyclesTotal: 1706.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.6130484144784,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B17',
    unitFullId: 'Smart_Hill/B17/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '2053692546559302',
    fullFrontendId: 'Smart_Hill/B17/Rack_02',
    ageInYears: 5.205479452054795,
    throughputTotal: 682400000.0,
    cyclesTotal: 1706.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.27951480368229,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B17',
    unitFullId: 'Smart_Hill/B17/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '70581178585199271',
    fullFrontendId: 'Smart_Hill/B17/Rack_03',
    ageInYears: 5.205479452054795,
    throughputTotal: 682400000.0,
    cyclesTotal: 1706.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.87748363672385,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B17',
    unitFullId: 'Smart_Hill/B17/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '52500410976540328',
    fullFrontendId: 'Smart_Hill/B17/Rack_04',
    ageInYears: 5.205479452054795,
    throughputTotal: 682400000.0,
    cyclesTotal: 1706.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.78586151199221,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B17',
    unitFullId: 'Smart_Hill/B17/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '24956673337015736',
    fullFrontendId: 'Smart_Hill/B17/Rack_05',
    ageInYears: 5.205479452054795,
    throughputTotal: 682400000.0,
    cyclesTotal: 1706.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.18457001471553,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B17',
    unitFullId: 'Smart_Hill/B17/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '35910466305307305',
    fullFrontendId: 'Smart_Hill/B17/Rack_06',
    ageInYears: 5.205479452054795,
    throughputTotal: 682400000.0,
    cyclesTotal: 1706.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.55073054454556,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B17',
    unitFullId: 'Smart_Hill/B17/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '32300504484497934',
    fullFrontendId: 'Smart_Hill/B17/Rack_07',
    ageInYears: 5.205479452054795,
    throughputTotal: 682400000.0,
    cyclesTotal: 1706.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.45287204413479,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B17',
    unitFullId: 'Smart_Hill/B17/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '50619950495859730',
    fullFrontendId: 'Smart_Hill/B18/Rack_01',
    ageInYears: 5.205479452054795,
    throughputTotal: 682400000.0,
    cyclesTotal: 1706.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.66984872651895,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B18',
    unitFullId: 'Smart_Hill/B18/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '38645722419021758',
    fullFrontendId: 'Smart_Hill/B18/Rack_02',
    ageInYears: 5.205479452054795,
    throughputTotal: 682400000.0,
    cyclesTotal: 1706.0,
    sohPenaltyMax: 0.0,
    sohAccure: 88.96978222108523,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B18',
    unitFullId: 'Smart_Hill/B18/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '28862791299318153',
    fullFrontendId: 'Smart_Hill/B18/Rack_03',
    ageInYears: 5.205479452054795,
    throughputTotal: 682400000.0,
    cyclesTotal: 1706.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.46507469725879,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B18',
    unitFullId: 'Smart_Hill/B18/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '45065540055841262',
    fullFrontendId: 'Smart_Hill/B18/Rack_04',
    ageInYears: 5.205479452054795,
    throughputTotal: 682400000.0,
    cyclesTotal: 1706.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.57678660531413,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B18',
    unitFullId: 'Smart_Hill/B18/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '38070773761938067',
    fullFrontendId: 'Smart_Hill/B18/Rack_05',
    ageInYears: 5.205479452054795,
    throughputTotal: 682400000.0,
    cyclesTotal: 1706.0,
    sohPenaltyMax: 0.0,
    sohAccure: 88.73163741333232,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B18',
    unitFullId: 'Smart_Hill/B18/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '63722519976061634',
    fullFrontendId: 'Smart_Hill/B18/Rack_06',
    ageInYears: 5.205479452054795,
    throughputTotal: 682400000.0,
    cyclesTotal: 1706.0,
    sohPenaltyMax: 0.0,
    sohAccure: 88.90428170545952,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B18',
    unitFullId: 'Smart_Hill/B18/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '52481637789387812',
    fullFrontendId: 'Smart_Hill/B18/Rack_07',
    ageInYears: 5.205479452054795,
    throughputTotal: 682400000.0,
    cyclesTotal: 1706.0,
    sohPenaltyMax: 0.0,
    sohAccure: 88.64748960593123,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B18',
    unitFullId: 'Smart_Hill/B18/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '48688770396985074',
    fullFrontendId: 'Smart_Hill/B19/Rack_01',
    ageInYears: 5.205479452054795,
    throughputTotal: 682400000.0,
    cyclesTotal: 1706.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.17843720892589,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B19',
    unitFullId: 'Smart_Hill/B19/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '14460835168906315',
    fullFrontendId: 'Smart_Hill/B19/Rack_02',
    ageInYears: 5.205479452054795,
    throughputTotal: 682400000.0,
    cyclesTotal: 1706.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.47452193599804,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B19',
    unitFullId: 'Smart_Hill/B19/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '52998696880078229',
    fullFrontendId: 'Smart_Hill/B19/Rack_03',
    ageInYears: 5.205479452054795,
    throughputTotal: 682400000.0,
    cyclesTotal: 1706.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.70996637488805,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B19',
    unitFullId: 'Smart_Hill/B19/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '31443814677279121',
    fullFrontendId: 'Smart_Hill/B19/Rack_04',
    ageInYears: 5.205479452054795,
    throughputTotal: 682400000.0,
    cyclesTotal: 1706.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.28148769338519,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B19',
    unitFullId: 'Smart_Hill/B19/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '49265051464892748',
    fullFrontendId: 'Smart_Hill/B19/Rack_05',
    ageInYears: 5.205479452054795,
    throughputTotal: 682400000.0,
    cyclesTotal: 1706.0,
    sohPenaltyMax: 1.0,
    sohAccure: 86.0,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B19',
    unitFullId: 'Smart_Hill/B19/Rack_05',
    dataStatus: 1,
    complianceStatus: 1,
    warrantyCoverage: 2,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 1,
    nUnitsOperationIssues: 1,
  },
  {
    id: '38695840649889281',
    fullFrontendId: 'Smart_Hill/B19/Rack_06',
    ageInYears: 5.205479452054795,
    throughputTotal: 682400000.0,
    cyclesTotal: 1706.0,
    sohPenaltyMax: 0.0,
    sohAccure: 88.84522882179479,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B19',
    unitFullId: 'Smart_Hill/B19/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '1495526027727418',
    fullFrontendId: 'Smart_Hill/B19/Rack_07',
    ageInYears: 5.205479452054795,
    throughputTotal: 682400000.0,
    cyclesTotal: 1706.0,
    sohPenaltyMax: 0.0,
    sohAccure: 88.74824452745271,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B19',
    unitFullId: 'Smart_Hill/B19/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '48971081830872427',
    fullFrontendId: 'Smart_Hill/B20/Rack_01',
    ageInYears: 5.205479452054795,
    throughputTotal: 685600000.0,
    cyclesTotal: 1714.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.24259494959027,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B20',
    unitFullId: 'Smart_Hill/B20/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '48757661508021137',
    fullFrontendId: 'Smart_Hill/B20/Rack_02',
    ageInYears: 5.205479452054795,
    throughputTotal: 685600000.0,
    cyclesTotal: 1714.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.37447889394105,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B20',
    unitFullId: 'Smart_Hill/B20/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '4809815686882139',
    fullFrontendId: 'Smart_Hill/B20/Rack_03',
    ageInYears: 5.205479452054795,
    throughputTotal: 685600000.0,
    cyclesTotal: 1714.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.24945083483102,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B20',
    unitFullId: 'Smart_Hill/B20/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '48860916300418370',
    fullFrontendId: 'Smart_Hill/B20/Rack_04',
    ageInYears: 5.205479452054795,
    throughputTotal: 685600000.0,
    cyclesTotal: 1714.0,
    sohPenaltyMax: 0.0,
    sohAccure: 88.63902662924728,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B20',
    unitFullId: 'Smart_Hill/B20/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '7158730309284118',
    fullFrontendId: 'Smart_Hill/B20/Rack_05',
    ageInYears: 5.205479452054795,
    throughputTotal: 685600000.0,
    cyclesTotal: 1714.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.23252324740541,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B20',
    unitFullId: 'Smart_Hill/B20/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '45886904170386958',
    fullFrontendId: 'Smart_Hill/B20/Rack_06',
    ageInYears: 5.205479452054795,
    throughputTotal: 685600000.0,
    cyclesTotal: 1714.0,
    sohPenaltyMax: 0.0,
    sohAccure: 88.8679184091078,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B20',
    unitFullId: 'Smart_Hill/B20/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '41779508507157494',
    fullFrontendId: 'Smart_Hill/B20/Rack_07',
    ageInYears: 5.205479452054795,
    throughputTotal: 685600000.0,
    cyclesTotal: 1714.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.46016102390827,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B20',
    unitFullId: 'Smart_Hill/B20/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '49858423950880505',
    fullFrontendId: 'Smart_Hill/B21/Rack_01',
    ageInYears: 5.205479452054795,
    throughputTotal: 685600000.0,
    cyclesTotal: 1714.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.36923873308831,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B21',
    unitFullId: 'Smart_Hill/B21/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '46870689238557165',
    fullFrontendId: 'Smart_Hill/B21/Rack_02',
    ageInYears: 5.205479452054795,
    throughputTotal: 685600000.0,
    cyclesTotal: 1714.0,
    sohPenaltyMax: 0.0,
    sohAccure: 88.97729532336105,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B21',
    unitFullId: 'Smart_Hill/B21/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '40768168588328948',
    fullFrontendId: 'Smart_Hill/B21/Rack_03',
    ageInYears: 5.205479452054795,
    throughputTotal: 685600000.0,
    cyclesTotal: 1714.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.0,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B21',
    unitFullId: 'Smart_Hill/B21/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '56563756851894281',
    fullFrontendId: 'Smart_Hill/B21/Rack_04',
    ageInYears: 5.205479452054795,
    throughputTotal: 685600000.0,
    cyclesTotal: 1714.0,
    sohPenaltyMax: 0.0,
    sohAccure: 88.94149520269256,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B21',
    unitFullId: 'Smart_Hill/B21/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '63486783724460205',
    fullFrontendId: 'Smart_Hill/B21/Rack_05',
    ageInYears: 5.205479452054795,
    throughputTotal: 685600000.0,
    cyclesTotal: 1714.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.2404555300773,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B21',
    unitFullId: 'Smart_Hill/B21/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '17145910332195513',
    fullFrontendId: 'Smart_Hill/B21/Rack_06',
    ageInYears: 5.205479452054795,
    throughputTotal: 683200000.0,
    cyclesTotal: 1708.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.0,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B21',
    unitFullId: 'Smart_Hill/B21/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '53382178548989907',
    fullFrontendId: 'Smart_Hill/B22/Rack_01',
    ageInYears: 5.205479452054795,
    throughputTotal: 683600000.0,
    cyclesTotal: 1709.0,
    sohPenaltyMax: 0.0,
    sohAccure: 88.96354144535859,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B22',
    unitFullId: 'Smart_Hill/B22/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '71499463918202387',
    fullFrontendId: 'Smart_Hill/B22/Rack_02',
    ageInYears: 5.205479452054795,
    throughputTotal: 683600000.0,
    cyclesTotal: 1709.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.4104732139146,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B22',
    unitFullId: 'Smart_Hill/B22/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '34365075744484327',
    fullFrontendId: 'Smart_Hill/B22/Rack_03',
    ageInYears: 5.205479452054795,
    throughputTotal: 683600000.0,
    cyclesTotal: 1709.0,
    sohPenaltyMax: 0.0,
    sohAccure: 90.0,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B22',
    unitFullId: 'Smart_Hill/B22/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '70713094701696135',
    fullFrontendId: 'Smart_Hill/B22/Rack_04',
    ageInYears: 5.205479452054795,
    throughputTotal: 683600000.0,
    cyclesTotal: 1709.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.02139740958054,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B22',
    unitFullId: 'Smart_Hill/B22/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '35413507095972812',
    fullFrontendId: 'Smart_Hill/B22/Rack_05',
    ageInYears: 5.205479452054795,
    throughputTotal: 683600000.0,
    cyclesTotal: 1709.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.22715015127288,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B22',
    unitFullId: 'Smart_Hill/B22/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '30429192677332961',
    fullFrontendId: 'Smart_Hill/B22/Rack_06',
    ageInYears: 5.205479452054795,
    throughputTotal: 688000000.0,
    cyclesTotal: 1720.0,
    sohPenaltyMax: 0.0,
    sohAccure: 90.0,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B22',
    unitFullId: 'Smart_Hill/B22/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '48252989460899083',
    fullFrontendId: 'Smart_Hill/B23/Rack_01',
    ageInYears: 5.205479452054795,
    throughputTotal: 687600000.0,
    cyclesTotal: 1719.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.0931644676551,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B23',
    unitFullId: 'Smart_Hill/B23/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '6489621000364283',
    fullFrontendId: 'Smart_Hill/B23/Rack_02',
    ageInYears: 5.205479452054795,
    throughputTotal: 687600000.0,
    cyclesTotal: 1719.0,
    sohPenaltyMax: 0.0,
    sohAccure: 88.8998958914826,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B23',
    unitFullId: 'Smart_Hill/B23/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '65365547490194511',
    fullFrontendId: 'Smart_Hill/B23/Rack_03',
    ageInYears: 5.205479452054795,
    throughputTotal: 687600000.0,
    cyclesTotal: 1719.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.84867679913417,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B23',
    unitFullId: 'Smart_Hill/B23/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '60789031339525557',
    fullFrontendId: 'Smart_Hill/B23/Rack_04',
    ageInYears: 5.205479452054795,
    throughputTotal: 687600000.0,
    cyclesTotal: 1719.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.26983832485077,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B23',
    unitFullId: 'Smart_Hill/B23/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '32266837888722812',
    fullFrontendId: 'Smart_Hill/B23/Rack_05',
    ageInYears: 5.205479452054795,
    throughputTotal: 687600000.0,
    cyclesTotal: 1719.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.04934160686147,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B23',
    unitFullId: 'Smart_Hill/B23/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '27329678242489183',
    fullFrontendId: 'Smart_Hill/B23/Rack_06',
    ageInYears: 5.205479452054795,
    throughputTotal: 687600000.0,
    cyclesTotal: 1719.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.32345323247952,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B23',
    unitFullId: 'Smart_Hill/B23/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '19444713267498720',
    fullFrontendId: 'Smart_Hill/B24/Rack_01',
    ageInYears: 5.205479452054795,
    throughputTotal: 687600000.0,
    cyclesTotal: 1719.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.0,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B24',
    unitFullId: 'Smart_Hill/B24/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '2094862441585329',
    fullFrontendId: 'Smart_Hill/B24/Rack_02',
    ageInYears: 5.205479452054795,
    throughputTotal: 687200000.0,
    cyclesTotal: 1718.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.0,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B24',
    unitFullId: 'Smart_Hill/B24/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '53965937023473965',
    fullFrontendId: 'Smart_Hill/B24/Rack_03',
    ageInYears: 5.205479452054795,
    throughputTotal: 687200000.0,
    cyclesTotal: 1718.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.44350926927228,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B24',
    unitFullId: 'Smart_Hill/B24/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '71460987189680773',
    fullFrontendId: 'Smart_Hill/B24/Rack_04',
    ageInYears: 5.205479452054795,
    throughputTotal: 687200000.0,
    cyclesTotal: 1718.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.48651157227344,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B24',
    unitFullId: 'Smart_Hill/B24/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '27728366972216984',
    fullFrontendId: 'Smart_Hill/B24/Rack_05',
    ageInYears: 5.205479452054795,
    throughputTotal: 687200000.0,
    cyclesTotal: 1718.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.10010891497609,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B24',
    unitFullId: 'Smart_Hill/B24/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '48444700418667565',
    fullFrontendId: 'Smart_Hill/B24/Rack_06',
    ageInYears: 5.205479452054795,
    throughputTotal: 687200000.0,
    cyclesTotal: 1718.0,
    sohPenaltyMax: 0.0,
    sohAccure: 89.08651378706585,
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B24',
    unitFullId: 'Smart_Hill/B24/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 88.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '35079599492552134',
    fullFrontendId: 'Sunset_Plaza/B01/Rack_01',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.4174844908545,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B01',
    unitFullId: 'Sunset_Plaza/B01/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '60657763325243915',
    fullFrontendId: 'Sunset_Plaza/B01/Rack_02',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 92.80942365057932,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B01',
    unitFullId: 'Sunset_Plaza/B01/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '43258961377223634',
    fullFrontendId: 'Sunset_Plaza/B01/Rack_03',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.04544268134043,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B01',
    unitFullId: 'Sunset_Plaza/B01/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '23354183706937396',
    fullFrontendId: 'Sunset_Plaza/B01/Rack_04',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.91006228023336,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B01',
    unitFullId: 'Sunset_Plaza/B01/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '1848370142396384',
    fullFrontendId: 'Sunset_Plaza/B01/Rack_05',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.99349031405039,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B01',
    unitFullId: 'Sunset_Plaza/B01/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '18480505217750404',
    fullFrontendId: 'Sunset_Plaza/B01/Rack_06',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.42528918813309,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B01',
    unitFullId: 'Sunset_Plaza/B01/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '43744028884453053',
    fullFrontendId: 'Sunset_Plaza/B01/Rack_07',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.67296708891674,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B01',
    unitFullId: 'Sunset_Plaza/B01/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '17553539178570896',
    fullFrontendId: 'Sunset_Plaza/B01/Rack_08',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.59337504636306,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B01',
    unitFullId: 'Sunset_Plaza/B01/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '22692834682381922',
    fullFrontendId: 'Sunset_Plaza/B01/Rack_09',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 94.42366424253657,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B01',
    unitFullId: 'Sunset_Plaza/B01/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '335446477564378',
    fullFrontendId: 'Sunset_Plaza/B01/Rack_10',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.83587247343037,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B01',
    unitFullId: 'Sunset_Plaza/B01/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '62459970151819100',
    fullFrontendId: 'Sunset_Plaza/B02/Rack_01',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.46162472255577,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B02',
    unitFullId: 'Sunset_Plaza/B02/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '28726395311334323',
    fullFrontendId: 'Sunset_Plaza/B02/Rack_02',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.21333786781987,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B02',
    unitFullId: 'Sunset_Plaza/B02/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '71351724769407902',
    fullFrontendId: 'Sunset_Plaza/B02/Rack_03',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.01806610392273,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B02',
    unitFullId: 'Sunset_Plaza/B02/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '41945816501081001',
    fullFrontendId: 'Sunset_Plaza/B02/Rack_04',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.56103909076016,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B02',
    unitFullId: 'Sunset_Plaza/B02/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '53265910630541263',
    fullFrontendId: 'Sunset_Plaza/B02/Rack_05',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.27309477641471,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B02',
    unitFullId: 'Sunset_Plaza/B02/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '21037161735465121',
    fullFrontendId: 'Sunset_Plaza/B02/Rack_06',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.0733238871207,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B02',
    unitFullId: 'Sunset_Plaza/B02/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '23563816371734243',
    fullFrontendId: 'Sunset_Plaza/B02/Rack_07',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.30602813472724,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B02',
    unitFullId: 'Sunset_Plaza/B02/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '68483868567566294',
    fullFrontendId: 'Sunset_Plaza/B02/Rack_08',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.17553559891569,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B02',
    unitFullId: 'Sunset_Plaza/B02/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '38135837023795626',
    fullFrontendId: 'Sunset_Plaza/B02/Rack_09',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 94.00614249052177,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B02',
    unitFullId: 'Sunset_Plaza/B02/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '38904549177912417',
    fullFrontendId: 'Sunset_Plaza/B02/Rack_10',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.76449192708483,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B02',
    unitFullId: 'Sunset_Plaza/B02/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '30714843013249091',
    fullFrontendId: 'Sunset_Plaza/B03/Rack_01',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.49760820760501,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B03',
    unitFullId: 'Sunset_Plaza/B03/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '25788169519644835',
    fullFrontendId: 'Sunset_Plaza/B03/Rack_02',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.94398324166701,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B03',
    unitFullId: 'Sunset_Plaza/B03/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '51197728079149998',
    fullFrontendId: 'Sunset_Plaza/B03/Rack_03',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.52321049229428,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B03',
    unitFullId: 'Sunset_Plaza/B03/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '67052612123657520',
    fullFrontendId: 'Sunset_Plaza/B03/Rack_04',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.24161473960152,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B03',
    unitFullId: 'Sunset_Plaza/B03/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '50017465982186910',
    fullFrontendId: 'Sunset_Plaza/B03/Rack_05',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.9569372231809,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B03',
    unitFullId: 'Sunset_Plaza/B03/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '65050616771379947',
    fullFrontendId: 'Sunset_Plaza/B03/Rack_06',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.6616730131054,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B03',
    unitFullId: 'Sunset_Plaza/B03/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '20647062452501250',
    fullFrontendId: 'Sunset_Plaza/B03/Rack_07',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.18882615370207,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B03',
    unitFullId: 'Sunset_Plaza/B03/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '55047696560349703',
    fullFrontendId: 'Sunset_Plaza/B03/Rack_08',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.44289839657492,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B03',
    unitFullId: 'Sunset_Plaza/B03/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '57672893553099070',
    fullFrontendId: 'Sunset_Plaza/B03/Rack_09',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.23731452398458,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B03',
    unitFullId: 'Sunset_Plaza/B03/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '46294422344634429',
    fullFrontendId: 'Sunset_Plaza/B03/Rack_10',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.0851600807107,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B03',
    unitFullId: 'Sunset_Plaza/B03/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '21031235340488397',
    fullFrontendId: 'Sunset_Plaza/B04/Rack_01',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.77785326425949,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B04',
    unitFullId: 'Sunset_Plaza/B04/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '52104864305480172',
    fullFrontendId: 'Sunset_Plaza/B04/Rack_02',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 94.07282499214104,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B04',
    unitFullId: 'Sunset_Plaza/B04/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '14078335744370971',
    fullFrontendId: 'Sunset_Plaza/B04/Rack_03',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.08042972785425,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B04',
    unitFullId: 'Sunset_Plaza/B04/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '20280190013234747',
    fullFrontendId: 'Sunset_Plaza/B04/Rack_04',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.66889077100717,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B04',
    unitFullId: 'Sunset_Plaza/B04/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '59713406893582856',
    fullFrontendId: 'Sunset_Plaza/B04/Rack_05',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.30480722926345,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B04',
    unitFullId: 'Sunset_Plaza/B04/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '11850571627739532',
    fullFrontendId: 'Sunset_Plaza/B04/Rack_06',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.3538623848706,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B04',
    unitFullId: 'Sunset_Plaza/B04/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '15619113561839834',
    fullFrontendId: 'Sunset_Plaza/B04/Rack_07',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.32228182272834,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B04',
    unitFullId: 'Sunset_Plaza/B04/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '56019295785122494',
    fullFrontendId: 'Sunset_Plaza/B04/Rack_08',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.24080276909605,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B04',
    unitFullId: 'Sunset_Plaza/B04/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '45233964787214109',
    fullFrontendId: 'Sunset_Plaza/B04/Rack_09',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.51455648838345,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B04',
    unitFullId: 'Sunset_Plaza/B04/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '25285983738490723',
    fullFrontendId: 'Sunset_Plaza/B04/Rack_10',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.25071496507668,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B04',
    unitFullId: 'Sunset_Plaza/B04/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '63358222093392503',
    fullFrontendId: 'Sunset_Plaza/B05/Rack_01',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.58113704773395,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B05',
    unitFullId: 'Sunset_Plaza/B05/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '20917327876710154',
    fullFrontendId: 'Sunset_Plaza/B05/Rack_02',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.48492856716526,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B05',
    unitFullId: 'Sunset_Plaza/B05/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '59723555043838889',
    fullFrontendId: 'Sunset_Plaza/B05/Rack_03',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.42831558594008,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B05',
    unitFullId: 'Sunset_Plaza/B05/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '71731959769522196',
    fullFrontendId: 'Sunset_Plaza/B05/Rack_04',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.22773090138752,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B05',
    unitFullId: 'Sunset_Plaza/B05/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '35527547318755671',
    fullFrontendId: 'Sunset_Plaza/B05/Rack_05',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.3269686008295,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B05',
    unitFullId: 'Sunset_Plaza/B05/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '2160660447756477',
    fullFrontendId: 'Sunset_Plaza/B05/Rack_06',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.72661736774772,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B05',
    unitFullId: 'Sunset_Plaza/B05/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '60955602330446930',
    fullFrontendId: 'Sunset_Plaza/B05/Rack_07',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.65027515628731,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B05',
    unitFullId: 'Sunset_Plaza/B05/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '12129653793088123',
    fullFrontendId: 'Sunset_Plaza/B05/Rack_08',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.20673342656043,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B05',
    unitFullId: 'Sunset_Plaza/B05/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '69127980137566436',
    fullFrontendId: 'Sunset_Plaza/B05/Rack_09',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.52979969162877,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B05',
    unitFullId: 'Sunset_Plaza/B05/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '7177186809680055',
    fullFrontendId: 'Sunset_Plaza/B05/Rack_10',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.72541613701154,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B05',
    unitFullId: 'Sunset_Plaza/B05/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '9175395037137693',
    fullFrontendId: 'Sunset_Plaza/B06/Rack_01',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 92.9991784156636,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B06',
    unitFullId: 'Sunset_Plaza/B06/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '43840062496099364',
    fullFrontendId: 'Sunset_Plaza/B06/Rack_02',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.66300805771398,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B06',
    unitFullId: 'Sunset_Plaza/B06/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '42336978694889711',
    fullFrontendId: 'Sunset_Plaza/B06/Rack_03',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.30121287231624,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B06',
    unitFullId: 'Sunset_Plaza/B06/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '31450277216898505',
    fullFrontendId: 'Sunset_Plaza/B06/Rack_04',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.67117960057794,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B06',
    unitFullId: 'Sunset_Plaza/B06/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '27192598374848000',
    fullFrontendId: 'Sunset_Plaza/B06/Rack_05',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.27102225303724,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B06',
    unitFullId: 'Sunset_Plaza/B06/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '28102434435720603',
    fullFrontendId: 'Sunset_Plaza/B06/Rack_06',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 92.95853536980064,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B06',
    unitFullId: 'Sunset_Plaza/B06/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '67399618892451013',
    fullFrontendId: 'Sunset_Plaza/B06/Rack_07',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.01173726863504,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B06',
    unitFullId: 'Sunset_Plaza/B06/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '33778278923414646',
    fullFrontendId: 'Sunset_Plaza/B06/Rack_08',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.51442548399841,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B06',
    unitFullId: 'Sunset_Plaza/B06/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '58760079855280155',
    fullFrontendId: 'Sunset_Plaza/B06/Rack_09',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.57791675051645,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B06',
    unitFullId: 'Sunset_Plaza/B06/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '34135204102489899',
    fullFrontendId: 'Sunset_Plaza/B06/Rack_10',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.22870501246868,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B06',
    unitFullId: 'Sunset_Plaza/B06/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '32437083433113149',
    fullFrontendId: 'Sunset_Plaza/B07/Rack_01',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.69157773763321,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B07',
    unitFullId: 'Sunset_Plaza/B07/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '4416030866688505',
    fullFrontendId: 'Sunset_Plaza/B07/Rack_02',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 94.0,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B07',
    unitFullId: 'Sunset_Plaza/B07/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '39763829747641606',
    fullFrontendId: 'Sunset_Plaza/B07/Rack_03',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.48017606040581,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B07',
    unitFullId: 'Sunset_Plaza/B07/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '49909109682713087',
    fullFrontendId: 'Sunset_Plaza/B07/Rack_04',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.13669514007127,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B07',
    unitFullId: 'Sunset_Plaza/B07/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '47543278782853757',
    fullFrontendId: 'Sunset_Plaza/B07/Rack_05',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.30444916765936,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B07',
    unitFullId: 'Sunset_Plaza/B07/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '8670882970050692',
    fullFrontendId: 'Sunset_Plaza/B07/Rack_06',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.0,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B07',
    unitFullId: 'Sunset_Plaza/B07/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '27283040611375227',
    fullFrontendId: 'Sunset_Plaza/B07/Rack_07',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.24187599041481,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B07',
    unitFullId: 'Sunset_Plaza/B07/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '38035985200834664',
    fullFrontendId: 'Sunset_Plaza/B07/Rack_08',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.38463333673106,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B07',
    unitFullId: 'Sunset_Plaza/B07/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '12174772515007284',
    fullFrontendId: 'Sunset_Plaza/B07/Rack_09',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.80188784276433,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B07',
    unitFullId: 'Sunset_Plaza/B07/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '65698748464844387',
    fullFrontendId: 'Sunset_Plaza/B07/Rack_10',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.32693243914305,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B07',
    unitFullId: 'Sunset_Plaza/B07/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '57142606006411498',
    fullFrontendId: 'Sunset_Plaza/B08/Rack_01',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.75070763361954,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B08',
    unitFullId: 'Sunset_Plaza/B08/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '10958493489220936',
    fullFrontendId: 'Sunset_Plaza/B08/Rack_02',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.16108794360271,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B08',
    unitFullId: 'Sunset_Plaza/B08/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '14754308508559561',
    fullFrontendId: 'Sunset_Plaza/B08/Rack_03',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.65894125337458,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B08',
    unitFullId: 'Sunset_Plaza/B08/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '37940774952553839',
    fullFrontendId: 'Sunset_Plaza/B08/Rack_04',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.93247058619737,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B08',
    unitFullId: 'Sunset_Plaza/B08/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '43509776735966515',
    fullFrontendId: 'Sunset_Plaza/B08/Rack_05',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 92.75850664996182,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B08',
    unitFullId: 'Sunset_Plaza/B08/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '58135030007642909',
    fullFrontendId: 'Sunset_Plaza/B08/Rack_06',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.26093142335885,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B08',
    unitFullId: 'Sunset_Plaza/B08/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '31414145010902092',
    fullFrontendId: 'Sunset_Plaza/B08/Rack_07',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.67312163815416,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B08',
    unitFullId: 'Sunset_Plaza/B08/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '17818051774895706',
    fullFrontendId: 'Sunset_Plaza/B08/Rack_08',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.4390863841871,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B08',
    unitFullId: 'Sunset_Plaza/B08/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '21013071767130086',
    fullFrontendId: 'Sunset_Plaza/B08/Rack_09',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.61134376201139,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B08',
    unitFullId: 'Sunset_Plaza/B08/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '10801577876736588',
    fullFrontendId: 'Sunset_Plaza/B08/Rack_10',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.31880444398526,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B08',
    unitFullId: 'Sunset_Plaza/B08/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '11375593899123091',
    fullFrontendId: 'Sunset_Plaza/B09/Rack_01',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.0,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B09',
    unitFullId: 'Sunset_Plaza/B09/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '47381622689104084',
    fullFrontendId: 'Sunset_Plaza/B09/Rack_02',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.45329682938238,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B09',
    unitFullId: 'Sunset_Plaza/B09/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '55709521646384897',
    fullFrontendId: 'Sunset_Plaza/B09/Rack_03',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.85033461849794,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B09',
    unitFullId: 'Sunset_Plaza/B09/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '7302099969241602',
    fullFrontendId: 'Sunset_Plaza/B09/Rack_04',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 94.0,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B09',
    unitFullId: 'Sunset_Plaza/B09/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '70994875044936437',
    fullFrontendId: 'Sunset_Plaza/B09/Rack_05',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.60128079862255,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B09',
    unitFullId: 'Sunset_Plaza/B09/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '16576714102091540',
    fullFrontendId: 'Sunset_Plaza/B09/Rack_06',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.37643691016326,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B09',
    unitFullId: 'Sunset_Plaza/B09/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '22491353107430450',
    fullFrontendId: 'Sunset_Plaza/B09/Rack_07',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.35371813277825,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B09',
    unitFullId: 'Sunset_Plaza/B09/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '71333124671386150',
    fullFrontendId: 'Sunset_Plaza/B09/Rack_08',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.37023254365411,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B09',
    unitFullId: 'Sunset_Plaza/B09/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '48508834435066572',
    fullFrontendId: 'Sunset_Plaza/B09/Rack_09',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.61833564271349,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B09',
    unitFullId: 'Sunset_Plaza/B09/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '69392820513795688',
    fullFrontendId: 'Sunset_Plaza/B09/Rack_10',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.37370465575393,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B09',
    unitFullId: 'Sunset_Plaza/B09/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '32660616734568296',
    fullFrontendId: 'Sunset_Plaza/B10/Rack_01',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 94.0,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B10',
    unitFullId: 'Sunset_Plaza/B10/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '60902590282422794',
    fullFrontendId: 'Sunset_Plaza/B10/Rack_02',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 94.12262023959363,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B10',
    unitFullId: 'Sunset_Plaza/B10/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '57024869034213961',
    fullFrontendId: 'Sunset_Plaza/B10/Rack_03',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.7613374110295,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B10',
    unitFullId: 'Sunset_Plaza/B10/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '782363481701581',
    fullFrontendId: 'Sunset_Plaza/B10/Rack_04',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.40219294034965,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B10',
    unitFullId: 'Sunset_Plaza/B10/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '17633189750374630',
    fullFrontendId: 'Sunset_Plaza/B10/Rack_05',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.0,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B10',
    unitFullId: 'Sunset_Plaza/B10/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '69530651245263361',
    fullFrontendId: 'Sunset_Plaza/B10/Rack_06',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.37757738809353,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B10',
    unitFullId: 'Sunset_Plaza/B10/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '48496545838971648',
    fullFrontendId: 'Sunset_Plaza/B10/Rack_07',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 92.88856263944665,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B10',
    unitFullId: 'Sunset_Plaza/B10/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '66841037154927878',
    fullFrontendId: 'Sunset_Plaza/B10/Rack_08',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.19757410672477,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B10',
    unitFullId: 'Sunset_Plaza/B10/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '70285715384723094',
    fullFrontendId: 'Sunset_Plaza/B10/Rack_09',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 92.93876242369224,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B10',
    unitFullId: 'Sunset_Plaza/B10/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '63758290874505012',
    fullFrontendId: 'Sunset_Plaza/B10/Rack_10',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.3945459547876,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B10',
    unitFullId: 'Sunset_Plaza/B10/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '28124858374632774',
    fullFrontendId: 'Sunset_Plaza/B11/Rack_01',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.50552551375687,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B11',
    unitFullId: 'Sunset_Plaza/B11/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '47245680462390628',
    fullFrontendId: 'Sunset_Plaza/B11/Rack_02',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 94.00293119368258,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B11',
    unitFullId: 'Sunset_Plaza/B11/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '45277147157392250',
    fullFrontendId: 'Sunset_Plaza/B11/Rack_03',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.59807821212925,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B11',
    unitFullId: 'Sunset_Plaza/B11/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '60679825139275974',
    fullFrontendId: 'Sunset_Plaza/B11/Rack_04',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.43426984135733,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B11',
    unitFullId: 'Sunset_Plaza/B11/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '56721372420565342',
    fullFrontendId: 'Sunset_Plaza/B11/Rack_05',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.74882167435504,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B11',
    unitFullId: 'Sunset_Plaza/B11/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '22447779129517378',
    fullFrontendId: 'Sunset_Plaza/B11/Rack_06',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 92.83665940729763,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B11',
    unitFullId: 'Sunset_Plaza/B11/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '5053232663135502',
    fullFrontendId: 'Sunset_Plaza/B11/Rack_07',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.57068436743258,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B11',
    unitFullId: 'Sunset_Plaza/B11/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '69456142569331638',
    fullFrontendId: 'Sunset_Plaza/B11/Rack_08',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.73125955816609,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B11',
    unitFullId: 'Sunset_Plaza/B11/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '31562446424791925',
    fullFrontendId: 'Sunset_Plaza/B11/Rack_09',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.05642412626605,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B11',
    unitFullId: 'Sunset_Plaza/B11/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '67775263096565749',
    fullFrontendId: 'Sunset_Plaza/B11/Rack_10',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.84312621296208,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B11',
    unitFullId: 'Sunset_Plaza/B11/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '57654656088194761',
    fullFrontendId: 'Sunset_Plaza/B12/Rack_01',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.60154892224833,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B12',
    unitFullId: 'Sunset_Plaza/B12/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '69268198814781637',
    fullFrontendId: 'Sunset_Plaza/B12/Rack_02',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.37541362582976,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B12',
    unitFullId: 'Sunset_Plaza/B12/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '12958175526162777',
    fullFrontendId: 'Sunset_Plaza/B12/Rack_03',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.68983455983188,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B12',
    unitFullId: 'Sunset_Plaza/B12/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '55125871943037286',
    fullFrontendId: 'Sunset_Plaza/B12/Rack_04',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 94.18120785734132,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B12',
    unitFullId: 'Sunset_Plaza/B12/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '56101294836430947',
    fullFrontendId: 'Sunset_Plaza/B12/Rack_05',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.55455987651754,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B12',
    unitFullId: 'Sunset_Plaza/B12/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '19837581716408589',
    fullFrontendId: 'Sunset_Plaza/B12/Rack_06',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.5744661758901,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B12',
    unitFullId: 'Sunset_Plaza/B12/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '56685402963130941',
    fullFrontendId: 'Sunset_Plaza/B12/Rack_07',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.36219173013792,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B12',
    unitFullId: 'Sunset_Plaza/B12/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '71429198033057053',
    fullFrontendId: 'Sunset_Plaza/B12/Rack_08',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.24504668916056,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B12',
    unitFullId: 'Sunset_Plaza/B12/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '19246583507602064',
    fullFrontendId: 'Sunset_Plaza/B12/Rack_09',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.74910074496327,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B12',
    unitFullId: 'Sunset_Plaza/B12/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '12846182028686806',
    fullFrontendId: 'Sunset_Plaza/B12/Rack_10',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.24317485222734,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B12',
    unitFullId: 'Sunset_Plaza/B12/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '51222084024797903',
    fullFrontendId: 'Sunset_Plaza/B13/Rack_01',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.52146987116582,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B13',
    unitFullId: 'Sunset_Plaza/B13/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '39170229262137232',
    fullFrontendId: 'Sunset_Plaza/B13/Rack_02',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.35670276597047,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B13',
    unitFullId: 'Sunset_Plaza/B13/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '3959540137519683',
    fullFrontendId: 'Sunset_Plaza/B13/Rack_03',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.64369394772392,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B13',
    unitFullId: 'Sunset_Plaza/B13/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '71907166678705129',
    fullFrontendId: 'Sunset_Plaza/B13/Rack_04',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.60009863158608,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B13',
    unitFullId: 'Sunset_Plaza/B13/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '2555834305027008',
    fullFrontendId: 'Sunset_Plaza/B13/Rack_05',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.81126198327738,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B13',
    unitFullId: 'Sunset_Plaza/B13/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '60725584928870431',
    fullFrontendId: 'Sunset_Plaza/B13/Rack_06',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.34699508034358,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B13',
    unitFullId: 'Sunset_Plaza/B13/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '66285326418257502',
    fullFrontendId: 'Sunset_Plaza/B13/Rack_07',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.41903751941199,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B13',
    unitFullId: 'Sunset_Plaza/B13/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '4958850007594793',
    fullFrontendId: 'Sunset_Plaza/B13/Rack_08',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.2063708852653,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B13',
    unitFullId: 'Sunset_Plaza/B13/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '23720656675694581',
    fullFrontendId: 'Sunset_Plaza/B13/Rack_09',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.36671202197716,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B13',
    unitFullId: 'Sunset_Plaza/B13/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '1076878984484970',
    fullFrontendId: 'Sunset_Plaza/B13/Rack_10',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.61319014791346,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B13',
    unitFullId: 'Sunset_Plaza/B13/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '23606146050822795',
    fullFrontendId: 'Sunset_Plaza/B14/Rack_01',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.7270965849936,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B14',
    unitFullId: 'Sunset_Plaza/B14/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '44938263530984610',
    fullFrontendId: 'Sunset_Plaza/B14/Rack_02',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.22335040274672,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B14',
    unitFullId: 'Sunset_Plaza/B14/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '61178743930976533',
    fullFrontendId: 'Sunset_Plaza/B14/Rack_03',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.7608817760317,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B14',
    unitFullId: 'Sunset_Plaza/B14/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '13560460717256566',
    fullFrontendId: 'Sunset_Plaza/B14/Rack_04',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.90669135764149,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B14',
    unitFullId: 'Sunset_Plaza/B14/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '54307276412371338',
    fullFrontendId: 'Sunset_Plaza/B14/Rack_05',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.62403047096711,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B14',
    unitFullId: 'Sunset_Plaza/B14/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '50815937617313589',
    fullFrontendId: 'Sunset_Plaza/B14/Rack_06',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 94.06303874376742,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B14',
    unitFullId: 'Sunset_Plaza/B14/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '3924482271833987',
    fullFrontendId: 'Sunset_Plaza/B14/Rack_07',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.26786324026892,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B14',
    unitFullId: 'Sunset_Plaza/B14/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '35662694575693330',
    fullFrontendId: 'Sunset_Plaza/B14/Rack_08',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.12660358900658,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B14',
    unitFullId: 'Sunset_Plaza/B14/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '8046538368927418',
    fullFrontendId: 'Sunset_Plaza/B14/Rack_09',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 92.96638392532871,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B14',
    unitFullId: 'Sunset_Plaza/B14/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '33278398670163058',
    fullFrontendId: 'Sunset_Plaza/B14/Rack_10',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.94881329344676,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B14',
    unitFullId: 'Sunset_Plaza/B14/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '13744263605342591',
    fullFrontendId: 'Sunset_Plaza/B15/Rack_01',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.69630969690621,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B15',
    unitFullId: 'Sunset_Plaza/B15/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '24013042471477128',
    fullFrontendId: 'Sunset_Plaza/B15/Rack_02',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.48332459872687,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B15',
    unitFullId: 'Sunset_Plaza/B15/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '33017895459320372',
    fullFrontendId: 'Sunset_Plaza/B15/Rack_03',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.58399058789594,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B15',
    unitFullId: 'Sunset_Plaza/B15/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '13955951463951367',
    fullFrontendId: 'Sunset_Plaza/B15/Rack_04',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.16235328581048,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B15',
    unitFullId: 'Sunset_Plaza/B15/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '68227863705749090',
    fullFrontendId: 'Sunset_Plaza/B15/Rack_05',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 94.23372559388505,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B15',
    unitFullId: 'Sunset_Plaza/B15/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '19560451941931963',
    fullFrontendId: 'Sunset_Plaza/B15/Rack_06',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.53876635459257,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B15',
    unitFullId: 'Sunset_Plaza/B15/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '48947680750511434',
    fullFrontendId: 'Sunset_Plaza/B15/Rack_07',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.53281843838147,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B15',
    unitFullId: 'Sunset_Plaza/B15/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '24607581275318618',
    fullFrontendId: 'Sunset_Plaza/B15/Rack_08',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.7177299871696,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B15',
    unitFullId: 'Sunset_Plaza/B15/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '43127281990156594',
    fullFrontendId: 'Sunset_Plaza/B15/Rack_09',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.64430276952102,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B15',
    unitFullId: 'Sunset_Plaza/B15/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '49125336693456848',
    fullFrontendId: 'Sunset_Plaza/B15/Rack_10',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.56716520728374,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B15',
    unitFullId: 'Sunset_Plaza/B15/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '42258704915988588',
    fullFrontendId: 'Sunset_Plaza/B16/Rack_01',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.2628576633664,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B16',
    unitFullId: 'Sunset_Plaza/B16/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '45160022361051610',
    fullFrontendId: 'Sunset_Plaza/B16/Rack_02',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.6414405071408,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B16',
    unitFullId: 'Sunset_Plaza/B16/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '206388036881247',
    fullFrontendId: 'Sunset_Plaza/B16/Rack_03',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 94.06460734894252,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B16',
    unitFullId: 'Sunset_Plaza/B16/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '22164310707695651',
    fullFrontendId: 'Sunset_Plaza/B16/Rack_04',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.90362601384649,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B16',
    unitFullId: 'Sunset_Plaza/B16/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '24697274947705184',
    fullFrontendId: 'Sunset_Plaza/B16/Rack_05',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.97795598799182,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B16',
    unitFullId: 'Sunset_Plaza/B16/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '60233673394640248',
    fullFrontendId: 'Sunset_Plaza/B16/Rack_06',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.34663529707065,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B16',
    unitFullId: 'Sunset_Plaza/B16/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '17580527052179391',
    fullFrontendId: 'Sunset_Plaza/B16/Rack_07',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.20311855392242,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B16',
    unitFullId: 'Sunset_Plaza/B16/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '33521742613704712',
    fullFrontendId: 'Sunset_Plaza/B16/Rack_08',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.4622639239701,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B16',
    unitFullId: 'Sunset_Plaza/B16/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '18833102232759435',
    fullFrontendId: 'Sunset_Plaza/B16/Rack_09',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.51671747368661,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B16',
    unitFullId: 'Sunset_Plaza/B16/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '17913064679708754',
    fullFrontendId: 'Sunset_Plaza/B16/Rack_10',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.82825745554129,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B16',
    unitFullId: 'Sunset_Plaza/B16/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '53828508804375926',
    fullFrontendId: 'Sunset_Plaza/B17/Rack_01',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 92.99226061108556,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B17',
    unitFullId: 'Sunset_Plaza/B17/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '48670519692338213',
    fullFrontendId: 'Sunset_Plaza/B17/Rack_02',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.95886509583818,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B17',
    unitFullId: 'Sunset_Plaza/B17/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '13208265763049318',
    fullFrontendId: 'Sunset_Plaza/B17/Rack_03',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.4525976304263,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B17',
    unitFullId: 'Sunset_Plaza/B17/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '19552475340290172',
    fullFrontendId: 'Sunset_Plaza/B17/Rack_04',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.37193567901578,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B17',
    unitFullId: 'Sunset_Plaza/B17/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '4898952035945218',
    fullFrontendId: 'Sunset_Plaza/B17/Rack_05',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.19636868742195,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B17',
    unitFullId: 'Sunset_Plaza/B17/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '15850813590925959',
    fullFrontendId: 'Sunset_Plaza/B17/Rack_06',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.00354299844027,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B17',
    unitFullId: 'Sunset_Plaza/B17/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '52521187362286770',
    fullFrontendId: 'Sunset_Plaza/B17/Rack_07',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.74695117518857,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B17',
    unitFullId: 'Sunset_Plaza/B17/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '54430293987184687',
    fullFrontendId: 'Sunset_Plaza/B17/Rack_08',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.52199539015652,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B17',
    unitFullId: 'Sunset_Plaza/B17/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '23213235943792871',
    fullFrontendId: 'Sunset_Plaza/B17/Rack_09',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.11301173007769,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B17',
    unitFullId: 'Sunset_Plaza/B17/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '26385332725240731',
    fullFrontendId: 'Sunset_Plaza/B17/Rack_10',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.11147636838092,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B17',
    unitFullId: 'Sunset_Plaza/B17/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '43089236366906994',
    fullFrontendId: 'Sunset_Plaza/B18/Rack_01',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.39926459021297,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B18',
    unitFullId: 'Sunset_Plaza/B18/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '63768954693150466',
    fullFrontendId: 'Sunset_Plaza/B18/Rack_02',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 94.00070645758682,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B18',
    unitFullId: 'Sunset_Plaza/B18/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '35095534864345407',
    fullFrontendId: 'Sunset_Plaza/B18/Rack_03',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.42212259459092,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B18',
    unitFullId: 'Sunset_Plaza/B18/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '17801485971336608',
    fullFrontendId: 'Sunset_Plaza/B18/Rack_04',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.04905711406457,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B18',
    unitFullId: 'Sunset_Plaza/B18/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '49077479741439416',
    fullFrontendId: 'Sunset_Plaza/B18/Rack_05',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.42627708077421,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B18',
    unitFullId: 'Sunset_Plaza/B18/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '45129314086819167',
    fullFrontendId: 'Sunset_Plaza/B18/Rack_06',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.4181829290757,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B18',
    unitFullId: 'Sunset_Plaza/B18/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '6179717183598613',
    fullFrontendId: 'Sunset_Plaza/B18/Rack_07',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 92.69093400711753,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B18',
    unitFullId: 'Sunset_Plaza/B18/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '37367737864105152',
    fullFrontendId: 'Sunset_Plaza/B18/Rack_08',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.48371154004465,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B18',
    unitFullId: 'Sunset_Plaza/B18/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '69588164753444757',
    fullFrontendId: 'Sunset_Plaza/B18/Rack_09',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.4307196409374,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B18',
    unitFullId: 'Sunset_Plaza/B18/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '68228446603551146',
    fullFrontendId: 'Sunset_Plaza/B18/Rack_10',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.70886190944402,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B18',
    unitFullId: 'Sunset_Plaza/B18/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '17284153773455137',
    fullFrontendId: 'Sunset_Plaza/B19/Rack_01',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 94.0546868284836,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B19',
    unitFullId: 'Sunset_Plaza/B19/Rack_01',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '48806938598024116',
    fullFrontendId: 'Sunset_Plaza/B19/Rack_02',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.83796950886433,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B19',
    unitFullId: 'Sunset_Plaza/B19/Rack_02',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '11986804017601896',
    fullFrontendId: 'Sunset_Plaza/B19/Rack_03',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.41933339283355,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B19',
    unitFullId: 'Sunset_Plaza/B19/Rack_03',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '61098197719043385',
    fullFrontendId: 'Sunset_Plaza/B19/Rack_04',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.1680422273775,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B19',
    unitFullId: 'Sunset_Plaza/B19/Rack_04',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '66184847427690058',
    fullFrontendId: 'Sunset_Plaza/B19/Rack_05',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 94.27200794097496,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B19',
    unitFullId: 'Sunset_Plaza/B19/Rack_05',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '26575516861154073',
    fullFrontendId: 'Sunset_Plaza/B19/Rack_06',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.51776553020434,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B19',
    unitFullId: 'Sunset_Plaza/B19/Rack_06',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '34619842153783870',
    fullFrontendId: 'Sunset_Plaza/B19/Rack_07',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.50417878757388,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B19',
    unitFullId: 'Sunset_Plaza/B19/Rack_07',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '10040882121069437',
    fullFrontendId: 'Sunset_Plaza/B19/Rack_08',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.492762473867,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B19',
    unitFullId: 'Sunset_Plaza/B19/Rack_08',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '60695585843713864',
    fullFrontendId: 'Sunset_Plaza/B19/Rack_09',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.55942542823036,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B19',
    unitFullId: 'Sunset_Plaza/B19/Rack_09',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
  {
    id: '26927875387232999',
    fullFrontendId: 'Sunset_Plaza/B19/Rack_10',
    ageInYears: 2.0,
    throughputTotal: 58400000.0,
    cyclesTotal: 146.0,
    sohPenaltyMax: 0.0,
    sohAccure: 93.45669187642282,
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B19',
    unitFullId: 'Sunset_Plaza/B19/Rack_10',
    dataStatus: 1,
    complianceStatus: 0,
    warrantyCoverage: 0,
    sohGuaranteed: 91.0,
    nUnitsPerformanceIssues: 0,
    nUnitsOperationIssues: 0,
  },
];

export const dummyWarrantyIDStatuses: WarrantyIDStatus[] =
  dummyWarrantyIDStatusesRaw.map((statusRaw) => {
    const dataStatus = getDataStatusFromCode(statusRaw.dataStatus);
    const complianceStatus = getComplianceStatusFromCode(
      statusRaw.complianceStatus,
    );
    const warrantyCoverageStatus = getWarrantyCoverageStatusFromCode(
      statusRaw.warrantyCoverage,
    );

    return {
      ...statusRaw,
      dataStatus,
      complianceStatus,
      warrantyCoverageStatus,
      suggestedAction: getSuggestedAction(
        warrantyCoverageStatus,
        complianceStatus,
        dataStatus,
      ),
    };
  });

export function getSuggestedAction(
  warrantyCoverage?: WarrantyCoverageStatus,
  complianceStatus?: ComplianceStatus,
  dataStatus?: DataStatus,
): string | undefined {
  if (dataStatus === DataStatus.NO_DATA) {
    return 'Insufficient data';
  }

  if (complianceStatus === undefined || warrantyCoverage === undefined) {
    return 'Insufficient data';
  }

  const isNonCompliant = complianceStatus === ComplianceStatus.NON_COMPLIANT;
  const isAtRisk = complianceStatus === ComplianceStatus.AT_RISK;
  const isCaseOpen = warrantyCoverage === WarrantyCoverageStatus.CASE_OPEN;
  const isExpired = warrantyCoverage === WarrantyCoverageStatus.EXPIRED;

  if (isNonCompliant && isCaseOpen) {
    return 'Review compliance and contact provider';
  }

  if (isNonCompliant) {
    return 'Review warranty compliance';
  }

  if (isAtRisk) {
    return 'Monitor and adjust operation';
  }

  if (isCaseOpen) {
    return 'Initiate capacity test';
  }

  if (isExpired) {
    return 'Consider replacement';
  }

  return undefined;
}
